// src/pages/AlertsPage.js
import React, { useState, useEffect, useCallback, useMemo, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  Tabs,
  Table,
  Button,
  Input,
  Radio,
  message,
  Form,
  Row,
  Col,
  InputNumber,
  Checkbox,
  Popconfirm,
  Select,
  Switch,
  Typography,
  Space,
  DatePicker,
  Card,
  Badge,
  Modal,
  Tooltip,
  Divider,
  Tag,
  Dropdown,
  Menu,
  Spin,
  Empty,
  Collapse,
} from "antd";
import moment from "moment";
import dayjs from "dayjs";
import { 
  ReloadOutlined, 
  EyeOutlined, 
  EditFilled, 
  DeleteFilled,
  PlusOutlined,
  MailOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import { alertApi, normalizeLokiLabelsResponse } from "../services/alertApi";
import { buildAmpAlertPayload, normalizeAmpAlert, parseAmpExpressionParts, AMP_PLATFORM, getGrafanaThresholdInfo } from "../utils/ampAlertHelpers";
import { pipelineDiscoveryService } from "../services/pipelineDiscoveryService";
import { accountService } from "../services/accountService";
import {
  buildLineageAwareRcaPrompt,
  resolveLineageContextForAlert,
} from "../utils/lineageAlertContext";
import IsEnabled from "../rolepermission";
import { useAuth } from "../context/AuthContext";
import { useTheme } from '../context/ThemeContext';
import PromQLBuilder from "../components/PromQLBuilder";
import LokiBuilder from "../components/LokiBuilder";
import ClairAIAlertCreator from "../components/ClairAIAlertCreator";
import EnhancedAlertRulesView from "../components/EnhancedAlertRulesView";
import AlertSilenceIconButton from "../components/AlertSilenceIconButton";
// import QueryBuilder from "../components/QueryBuilder";
import "../styles/builder.css";
import OperationItem from "../components/OperationItem";
import OperationMenu from "../components/OperationMenu";

const { Panel } = Collapse; 
const { TabPane } = Tabs;
const { Option } = Select;
const { Title, Text } = Typography;

// ==================== Expression Builder ====================
// const ExpressionBuilder = ({ onChange, value }) => {
//   // Core state
//   const [config, setConfig] = useState([]);
//   const [loading, setLoading] = useState(false);
//   // const [namespace, setNamespace] = useState("");
//   const [metric, setMetric] = useState("");
//   const [metrics, setMetrics] = useState([]);
//   const [labelKeys, setLabelKeys] = useState([]);
//   const [selectedLabelKey, setSelectedLabelKey] = useState("");
//   const [stats, setStats] = useState([]);
//   const [filters, setFilters] = useState([]);
//   const [lastGeneratedExpr, setLastGeneratedExpr] = useState("");

//   // Reset form state if component unmounts
//   useEffect(() => {
//     return () => {
//       // Cleanup function to reset state when component unmounts
//       resetState();
//     };
//   }, []);
//   useEffect(() => {
//     if (!metric || !metrics || metrics.length === 0) return;
//     const metricData = metrics.find((m) => m.__name__ === metric);

//     if (metricData) {
//       // Extract label keys (exclude __name__ and name)
//       const keys = Object.keys(metricData).filter((k) => k !== "__name__");

//       setLabelKeys(keys); // new state for label keys
//     }
//   }, [metric, metrics]);
//   // Load metrics config on component mount
//   useEffect(() => {
//     setLoading(true);
//     alertApi
//       .getMetricsConfig()
//       .then((cfg) => {
//         setMetrics(cfg.data);
//         setLoading(false);
//       })
//       .catch(() => {
//         message.error("Failed to load metrics configuration");
//         setLoading(false);
//       });
//   }, []);

//   // Parse existing expression when provided (for editing)
//   useEffect(() => {
//     if (value && value !== lastGeneratedExpr) {
//       try {
//         // Parse simple expressions like: avg(AWS/EC2.CPUUtilization{InstanceId="i-1234"})
//         const regex = /(\w+)\((?:{([^}]+)})?/;
//         const match = value.match(regex);

//         setLastGeneratedExpr(value);
//         if (match) {
//           // const statistic = match[1];
//           const metricPath = match[1].trim();
//           const filterStr = match[2];

//           // Split the metric path into namespace and metric name
//           const parts = metricPath;
//           if (parts) {
//             // const ns = parts[0];
//             const met = parts;

//             //setNamespace(ns);
//             setMetric(met);
//             // setStats([statistic]);

//             // Parse filters like: key="value",key2="value2"
//             if (filterStr) {
//               const filterRegex = /([^=!]+)(=|!=)"([^"]+)"/g;
//               const parsedFilters = [];
//               let filterMatch;

//               while ((filterMatch = filterRegex.exec(filterStr)) !== null) {
//                 //console.log("filterMatch", filterMatch[1]);
//                 parsedFilters.push({
//                   key: filterMatch[1].trim().replace(",", ""),
//                   operator: filterMatch[2],
//                   value: filterMatch[3].trim(),
//                 });
//               }

//               if (parsedFilters.length > 0) {
//                 setFilters(parsedFilters);
//               } else {
//                 setFilters([]);
//               }
//             } else {
//               setFilters([]);
//             }
//           }
//         }
//       } catch (e) {
//         console.error("Failed to parse expression", e);
//       }
//     }
//   }, [value, lastGeneratedExpr]);

//   // Reset all state
//   const resetState = () => {
//     // setNamespace("");
//     setMetric("");
//     setMetrics([]);
//     setStats([]);
//     setFilters([]);
//     setLastGeneratedExpr("");
//   };

//   // Handle namespace change
//   // const
//   //  = (ns) => {
//   //   setNamespace(ns);
//   //   setMetric("");
//   //   setStats([]);
//   //   setFilters([]);
//   //   // Clear the expression when namespace changes
//   //   updateExpressionWithDelay("");
//   // };

//   // Get a list of available namespaces
//   //const labelKeysFilter = Object.keys(config);
//   // Handle metric change
//   const handleMetricChange = (met) => {
//     setMetric(met);

//     // Clear the stats when metric changes
//     //setStats([]);
//     // Clear the expression when metric changes
//     updateExpressionWithDelay("");

//     updateExpression(met, []);
//   };

//   const handleLabelkeyChange = (idx, key) => {
//     const metricValue = metrics.find((m) => m.__name__ === metric);

//     // if (metricValue && key in metricValue) {
//     //   const lableValue = metricValue[key];
//     //   handleFilterChange(idx, "value", lableValue);
//     // }
//     const labelValue =
//       metricValue && Object.prototype.hasOwnProperty.call(metricValue, key)
//         ? metricValue[key]
//         : "";
//     const updatedFilters = [...filters];
//     updatedFilters[idx] = {
//       ...(updatedFilters[idx] || {}),
//       key,
//       value: labelValue,
//       operator: updatedFilters[idx]?.operator || "=",
//     };
//     setFilters(updatedFilters);
//     updateExpression(metric, updatedFilters);
//   };

//   // Handle statistic toggle
//   // const handleStatToggle = (stat) => {
//   //   const next = stats.includes(stat)
//   //     ? stats.filter((s) => s !== stat)
//   //     : [stat]; // Replace mode instead of toggle
//   //   setStats(next);

//   //   // Update the expression after a short delay
//   //   setTimeout(() => {
//   //     updateExpression(metric, next, filters);
//   //   }, 10);
//   // };

//   // Handle filter changes
//   const handleFilterChange = (idx, field, value) => {
//     const updatedFilters = [...filters];
//     updatedFilters[idx] = { ...(updatedFilters[idx] || {}), [field]: value };
//     setFilters(updatedFilters);
//     // Update expression after a small delay to avoid multiple updates
//     setTimeout(() => {
//       updateExpression(metric, updatedFilters);
//     }, 10);
//   };

//   // Build the filter string part of the expression
//   const buildFilterStr = (filtersList) => {
//     return filtersList
//       .filter((f) => f.key && f.value) // Skip incomplete filters
//       .map((f) => `${f.key}${f.operator}\"${f.value}\"`)
//       .join(",");
//   };

//   // Update the expression with a small delay
//   const updateExpressionWithDelay = (expr) => {
//     setLastGeneratedExpr(expr);
//     onChange(expr);
//   };

//   // Build and update the complete expression
//   const updateExpression = (met, filtersList) => {
//     if (!met) {
//       updateExpressionWithDelay("");
//       return;
//     }

//     const metricPath = `${met}`;
//     const validFilters = filtersList.filter((f) => f.key && f.value);
//     const filterPart =
//       validFilters.length > 0 ? `{${buildFilterStr(filtersList)}}` : "";

//     const expr = `${metricPath}(${filterPart})`;
//     updateExpressionWithDelay(expr);
//   };

//   // Get available metrics for the selected namespace
//   //const metrics = namespace ? config[namespace] || [] : [];

//   // Get the selected metric object
//   const selectedMetric = metrics.find((m) => m.__name__ === metric);

//   // Get a list of available namespaces
//   //const namespaces = Object.keys(config);

//   return (
//     <>
//       <div className="expression-builder">
//         <Spin spinning={loading} tip="Loading metrics...">
//           <Row gutter={[16, 16]}>
//             {/* <Col span={12}>
//               <Form.Item
//                 label={
//                   <span>
//                     Namespace
//                     <Tooltip title="The service namespace (e.g. AWS/EC2)">
//                       
//                     </Tooltip>
//                   </span>
//                 }
//                 style={{ marginBottom: 12 }}
//               >
//                 <Select
//                   placeholder="Select a namespace"
//                   value={namespace}
//                   onChange={handleNamespaceChange}
//                   showSearch
//                   allowClear
//                   loading={loading}
//                   disabled={loading}
//                   optionFilterProp="children"
//                   style={{ width: "100%" }}
//                 >
//                   {namespaces.map((ns) => (
//                     <Option key={ns} value={ns}>
//                       {ns}
//                     </Option>
//                   ))}
//                 </Select>
//               </Form.Item>
//             </Col> */}

//             <Col span={12}>
//               <Form.Item
//                 name="metric"
//                 label={
//                   <span>
//                     Metric
//                     <Tooltip title="The specific metric to monitor">
//                       
//                     </Tooltip>
//                   </span>
//                 }
//                 style={{ marginBottom: 12 }}
//                 rules={[
//                   {
//                     required: true,
//                     message: "Please select a metric",
//                   },
//                 ]}
//               >
//                 <Select
//                   placeholder="Select a metric"
//                   value={metric}
//                   onChange={handleMetricChange}
//                   showSearch
//                   allowClear
//                   disabled={loading}
//                   loading={loading}
//                   optionFilterProp="children"
//                   style={{ width: "100%" }}
//                 >
//                   {metrics.map((m, index) => (
//                     <Option key={`${m.__name__}-${index}`} value={m.__name__}>
//                       {m.__name__}
//                     </Option>
//                   ))}
//                 </Select>
//               </Form.Item>
//             </Col>
//           </Row>

//           {selectedMetric &&
//             selectedMetric.statistics &&
//             selectedMetric.statistics.length > 0 && (
//               <Form.Item
//                 label={
//                   <span>
//                     Statistic
//                     <Tooltip title="How to aggregate the metric data">
//                       
//                     </Tooltip>
//                   </span>
//                 }
//                 style={{ marginBottom: 16 }}
//                 required
//                 validateStatus={metric && stats.length === 0 ? "error" : ""}
//                 help={
//                   metric && stats.length === 0
//                     ? "Please select a statistic"
//                     : ""
//                 }
//               >
//                 {/* <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
//                   {selectedMetric.statistics.map((stat) => (
//                     <Tag
//                       key={stat}
//                       color={stats.includes(stat) ? "blue" : "default"}
//                       style={{
//                         cursor: "pointer",
//                         padding: "4px 8px",
//                         marginRight: 0,
//                       }}
//                       //onClick={() => handleStatToggle(stat)}
//                     >
//                       {stat}
//                       {stats.includes(stat) && (
//                         
//                       )}
//                     </Tag>
//                   ))}
//                 </div> */}
//               </Form.Item>
//             )}

//           <Divider orientation="left" plain style={{ margin: "12px 0" }}>
//             <span style={{ fontSize: 14, color: "#666" }}>
//               Label Filters (Optional)
//             </span>
//           </Divider>

//           <div style={{ marginBottom: 16 }}>
//             {filters.map((filter, idx) => (
//               <Card
//                 key={idx}
//                 size="small"
//                 style={{ marginBottom: 8 }}
//                 extra={
//                   <Button
//                     type="text"
//                     danger
////                     onClick={() => {
//                       const updatedFilters = [...filters];
//                       updatedFilters.splice(idx, 1);
//                       setFilters(updatedFilters);
//                       // Update expression after filter removal
//                       setTimeout(() => {
//                         updateExpression(metric, updatedFilters);
//                       }, 10);
//                     }}
//                   />
//                 }
//               >
//                 <Row gutter={[8, 0]} align="middle">
//                   <Col span={8}>
//                     {/* <Input
//                       placeholder="Label key"
//                       value={filter.key.account_id}
//                       onChange={(e) =>                   
//                         console.log("value",e.target.value) ||
//                         handleFilterChange(idx, "key", e.target.value)
                      
//                       }
//                     /> */}

//                     <Select
//                       placeholder="Label key"
//                       value={filter.key}
//                       onChange={(value) => {
//                         // handleFilterChange(idx, "key", value);
//                         handleLabelkeyChange(idx, value);
//                       }}
//                       showSearch
//                       allowClear
//                       disabled={loading}
//                       loading={loading}
//                       optionFilterProp="children"
//                       style={{ width: "100%" }}
//                     >
//                       {labelKeys.map((ns, index) => (
//                         <Option key={ns} value={ns}>
//                           {ns}
//                         </Option>
//                       ))}
//                     </Select>
//                   </Col>
//                   <Col span={4}>
//                     <Select
//                       value={filter.operator || "="}
//                       onChange={(op) => handleFilterChange(idx, "operator", op)}
//                       style={{ width: "100%" }}
//                     >
//                       <Option value="=">=</Option>
//                       <Option value="!=">!=</Option>
//                     </Select>
//                   </Col>
//                   <Col span={12}>
//                     <Input
//                       readOnly
//                       placeholder="Label value"
//                       value={filter.value}
//                       onChange={(e) =>
//                         handleFilterChange(idx, "value", e.target.value)
//                       }
//                     />
//                     {/* <h1 style={{color:'black'}}>{filter.value}</h1> */}
//                   </Col>
//                 </Row>
//               </Card>
//             ))}

//             <Button
//               type="dashed"
////               onClick={() => {
//                 const newFilters = [
//                   ...filters,
//                   { key: "", operator: "=", value: "" },
//                 ];
//                 setFilters(newFilters);
//               }}
//               style={{ width: "100%" }}
//               disabled={!metric}
//             >
//               Add Filter
//             </Button>
//           </div>
//           <Card
//             bordered={true}
//             style={{ marginTop: 16, background: "#f6ffed" }}
//             title="Generated Expression"
//             size="small"
//           >
//             <div
//               style={{
//                 fontFamily: "monospace",
//                 padding: 8,
//                 background: "#fff",
//                 border: "1px solid #d9d9d9",
//                 borderRadius: 2,
//                 wordBreak: "break-all",
//                 minHeight: "2em",
//               }}
//             >
//               {lastGeneratedExpr ? (
//                 <Text copyable>{lastGeneratedExpr}</Text>
//               ) : (
//                 <Text type="secondary">
//                   (Select namespace, metric and statistic)
//                 </Text>
//               )}
//             </div>
//           </Card>
//         </Spin>
//       </div>
//     </>
//   );
// };
const ExpressionBuilder = ({ onChange, value }) => {
  const { isDark } = useTheme();
  // Core state
  const [config, setConfig] = useState([]);
  const [loading, setLoading] = useState(false);
  const [metric, setMetric] = useState("");
  const [metrics, setMetrics] = useState([]);
  const [labelKeys, setLabelKeys] = useState([]);
  const [selectedLabelKey, setSelectedLabelKey] = useState("");
  const [stats, setStats] = useState([]);
  const [filters, setFilters] = useState([]);
  const [lastGeneratedExpr, setLastGeneratedExpr] = useState("");

  // --- Operations State ---
  const [ops, setOps] = useState([]);
  const rangeOptions = ["1m", "5m", "15m", "1h", "6h", "1d"];

  // Reset form state if component unmounts
  useEffect(() => () => resetState(), []);

  useEffect(() => {
    if (!metric || !metrics.length) return;
    const metricData = metrics.find((m) => m.__name__ === metric);
    if (metricData) {
      const keys = Object.keys(metricData).filter((k) => k !== "__name__").sort((a, b) => String(a).localeCompare(String(b)));
      setLabelKeys(keys);
    }
  }, [metric, metrics]);

  // Load metrics config
  useEffect(() => {
    setLoading(true);
    alertApi
      .getMetricsConfig()
      .then((cfg) => {
        setMetrics(cfg.data);
        setLoading(false);
      })
      .catch(() => {
        message.error("Failed to load metrics configuration");
        setLoading(false);
      });
  }, []);

  // Parse incoming expression
  useEffect(() => {
    if (value && value !== lastGeneratedExpr) {
      try {
        const regex = /(\w+)\((?:{([^}]+)})?/;
        const match = value.match(regex);
        setLastGeneratedExpr(value);

        if (match) {
          const metricPath = match[1].trim();
          const filterStr = match[2];
          if (metricPath) setMetric(metricPath);

          if (filterStr) {
            const parsedFilters = [];
            const filterRegex = /([^=!]+)(=|!=)"([^"]+)"/g;
            let filterMatch;
            while ((filterMatch = filterRegex.exec(filterStr)) !== null) {
              parsedFilters.push({
                key: filterMatch[1].trim().replace(",", ""),
                operator: filterMatch[2],
                value: filterMatch[3].trim(),
              });
            }
            setFilters(parsedFilters.length ? parsedFilters : []);
          } else setFilters([]);
        }
      } catch (e) {
        console.error("Failed to parse expression", e);
      }
    }
  }, [value, lastGeneratedExpr]);

  const resetState = () => {
    setMetric("");
    setMetrics([]);
    setStats([]);
    setFilters([]);
    setOps([]);
    setLastGeneratedExpr("");
  };

  const handleMetricChange = (met) => {
    setMetric(met);
    updateExpressionWithDelay("");
    updateExpression(met, filters);
  };

  const handleLabelkeyChange = (idx, key) => {
    const metricValue = metrics.find((m) => m.__name__ === metric);
    const labelValue =
      metricValue && Object.prototype.hasOwnProperty.call(metricValue, key)
        ? metricValue[key]
        : "";
    const updatedFilters = [...filters];
    updatedFilters[idx] = {
      ...(updatedFilters[idx] || {}),
      key,
      value: labelValue,
      operator: updatedFilters[idx]?.operator || "=",
    };
    setFilters(updatedFilters);
    updateExpression(metric, updatedFilters);
  };

  const handleFilterChange = (idx, field, value) => {
    const updatedFilters = [...filters];
    updatedFilters[idx] = { ...(updatedFilters[idx] || {}), [field]: value };
    setFilters(updatedFilters);
    setTimeout(() => updateExpression(metric, updatedFilters), 10);
  };

  const buildFilterStr = (filtersList) =>
    filtersList
      .filter((f) => f.key && f.value)
      .map((f) => `${f.key}${f.operator}"${f.value}"`)
      .join(",");

  const updateExpressionWithDelay = (expr) => {
    setLastGeneratedExpr(expr);
    onChange(expr);
  };

  // const updateExpression = (met, filtersList) => {
  //   if (!met) {
  //     updateExpressionWithDelay("");
  //     return;
  //   }

  //   const validFilters = filtersList.filter((f) => f.key && f.value);
  //   const filterPart =
  //     validFilters.length > 0 ? `{${buildFilterStr(validFilters)}}` : "";

  //   let expr = `${met}${filterPart ? filterPart : ""}`;

  //   // Apply operations if any
  //   if (ops.length) {
  //     ops.forEach((op) => {
  //       if (op.params?.range)
  //         expr = `${op.id}(${expr}[${op.params.range}])`;
  //       else if (op.params?.by?.length)
  //         expr = `${op.id} by (${op.params.by.join(",")}) (${expr})`;
  //       else expr = `${op.id}(${expr})`;
  //     });
  //   }

  //   updateExpressionWithDelay(expr);
  // };
  const updateExpression = (met, filtersList, opsList = ops) => {
  if (!met) {
    updateExpressionWithDelay("");
    return;
  }

  const validFilters = filtersList.filter((f) => f.key && f.value);
  const filterPart =
    validFilters.length > 0 ? `{${buildFilterStr(validFilters)}}` : "";

  let expr = `${met}${filterPart ? filterPart : ""}`;

  // Apply operations if any (PromQL-style)
  if (opsList.length) {
    opsList.forEach((op) => {
      if (op.params?.range)
        expr = `${op.id}(${expr}[${op.params.range}])`;
      else if (op.params?.by?.length)
        expr = `${op.id} by (${op.params.by.join(",")}) (${expr})`;
      else expr = `${op.id}(${expr})`;
    });
  }

  updateExpressionWithDelay(expr);
};

  // --- Operation handlers ---
// const addOp = (op) => {
//   const newOps = [...ops, op];
//   setOps(newOps);
// setTimeout(() => updateExpression(metric, filters), 1000);
// };

// const removeOp = (i) => {
//   const newOps = ops.filter((_, x) => x !== i);
//   setOps(newOps);
//  setTimeout(() => updateExpression(metric, filters), 1000);
// };

// const changeOpType = (i, newType) => {
//   const arr = [...ops];
//   arr[i].id = newType;
//   setOps(arr);
//  setTimeout(() => updateExpression(metric, filters), 1000);
// };

// const updateOpParam = (i, key, val) => {
//   const arr = [...ops];
//   arr[i].params = { ...arr[i].params, [key]: val };
//   setOps(arr);
  
//  setTimeout(() => updateExpression(metric, filters), 1000);
// };
// const addOp = (op) => {
//   const newOps = [...ops, op];
//   setOps(newOps);
//   updateExpression(metric, filters, newOps);
// };

// const removeOp = (i) => {
//   const newOps = ops.filter((_, x) => x !== i);
//   setOps(newOps);
//   updateExpression(metric, filters, newOps);
// };

// const changeOpType = (i, newType) => {
//   const newOps = [...ops];
//   newOps[i] = { ...newOps[i], id: newType };
//   setOps(newOps);
//   updateExpression(metric, filters, newOps);
// };

// const updateOpParam = (i, key, val) => {
//   const newOps = [...ops];
//   newOps[i].params = { ...newOps[i].params, [key]: val };
//   setOps(newOps);
//   updateExpression(metric, filters, newOps);
// };

const addOp = (op) => {
  const newOps = [...ops, op];
  setOps(newOps);
  updateExpression(metric, filters, newOps);
};

const removeOp = (i) => {
  const newOps = ops.filter((_, x) => x !== i);
  setOps(newOps);
  updateExpression(metric, filters, newOps);
};

const changeOpType = (i, newType) => {
  const newOps = [...ops];
  newOps[i] = { ...newOps[i], id: newType };
  setOps(newOps);
  updateExpression(metric, filters, newOps);
};

const updateOpParam = (i, key, val) => {
  const newOps = [...ops];
  newOps[i].params = { ...newOps[i].params, [key]: val };
  setOps(newOps);
  updateExpression(metric, filters, newOps);
};

  const selectedMetric = metrics.find((m) => m.__name__ === metric);

  return (
    <div className="expression-builder">
      <Spin spinning={loading} tip="Loading metrics...">
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Form.Item
              label={
                <span>
                  Metric
                  <Tooltip title="The specific metric to monitor">
                    
                  </Tooltip>
                </span>
              }
              style={{ marginBottom: 12 }}
              // rules={[{ required: true, message: "Please select a metric" }]}
            >
              <Select
                placeholder="Select a metric"
                value={metric}
                onChange={handleMetricChange}
                showSearch
                allowClear
                disabled={loading}
                loading={loading}
                optionFilterProp="children"
                style={{ width: "100%", maxWidth: "500px" }}
              >
                {metrics.map((m, index) => (
                  <Option key={`${m.__name__}-${index}`} value={m.__name__}>
                    {m.__name__}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        {/* Label Filters */}
        <Divider orientation="left" plain style={{ margin: "12px 0" }}>
          <span style={{ fontSize: 14, color: isDark ? "#adbac7" : "#666" }}>
            Label Filters (Optional)
          </span>
        </Divider>

        <div style={{ marginBottom: 16 }}>
          {filters.map((filter, idx) => (
            <Card
              key={idx}
              size="small"
              style={{ marginBottom: 8 }}
              extra={
                <Button
                  type="text"
                  danger
                  onClick={() => {
                    const updatedFilters = filters.filter((_, i) => i !== idx);
                    setFilters(updatedFilters);
                    setTimeout(() => updateExpression(metric, updatedFilters), 10);
                  }}
                />
              }
            >
              <Row gutter={[8, 0]} align="middle">
                <Col span={8}>
                  <Select
                    placeholder="Label key"
                    value={filter.key}
                    onChange={(v) => handleLabelkeyChange(idx, v)}
                    showSearch
                    allowClear
                    style={{ width: "100%" }}
                  >
                    {labelKeys.map((ns) => (
                      <Option key={ns} value={ns}>
                        {ns}
                      </Option>
                    ))}
                  </Select>
                </Col>
                <Col span={4}>
                  <Select
                    value={filter.operator || "="}
                    onChange={(op) => handleFilterChange(idx, "operator", op)}
                    style={{ width: "100%" }}
                  >
                    <Option value="=">=</Option>
                    <Option value="!=">!=</Option>
                  </Select>
                </Col>
                <Col span={12}>
                  <Input
                    readOnly
                    placeholder="Label value"
                    value={filter.value}
                    onChange={(e) =>
                      handleFilterChange(idx, "value", e.target.value)
                    }
                  />
                </Col>
              </Row>
            </Card>
          ))}

          <Button
            type="dashed"
            onClick={() =>
              setFilters([...filters, { key: "", operator: "=", value: "" }])
            }
            style={{ width: "100%" }}
            disabled={!metric}
          >
            Add Filter
          </Button>
        </div>

        {/* --- Operations Section --- */}
        <div className="gb-box">
          <div className="gb-box-top">
            <strong>Operations</strong>
            <OperationMenu mode="promql" onAdd={addOp} />
          </div>
          <div className="gb-box-body ops-list">
            {ops.length === 0 && (
              <div className="muted">No operations added — use +Operations</div>
            )}
            {ops.map((op, i) => (
              <OperationItem
                key={i}
                mode="promql"
                op={op}
                index={i}
                onRemove={removeOp}
                onChangeOpType={changeOpType}
                onUpdateParam={updateOpParam}
                labelKeys={labelKeys}
                rangeOptions={rangeOptions}
              />
            ))}
          </div>
        </div>

        {/* Expression Output */}
        <Card
          bordered
          style={{ marginTop: 16, background: "#f6ffed" }}
          title="Generated Expression"
          size="small"
        >
          <div
            style={{
              fontFamily: "monospace",
              padding: 8,
              background: "#fff",
              border: "1px solid #d9d9d9",
              borderRadius: 2,
              wordBreak: "break-all",
              minHeight: "2em",
            }}
          >
            {lastGeneratedExpr ? (
              <Text copyable>{lastGeneratedExpr}</Text>
            ) : (
              <Text type="secondary">
                (Select metric and apply filters/operations)
              </Text>
            )}
          </div>
        </Card>
      </Spin>
    </div>
  );
};

const normalizeSilences = (data) => {
  let list = [];
  if (Array.isArray(data)) list = data;
  else if (Array.isArray(data?.data)) list = data.data;
  else if (Array.isArray(data?.silences)) list = data.silences;

  return list.map((silence) => ({
    ...silence,
    id: silence?.id || silence?.silenceID || silence?.silenceId,
    matchers: (silence?.matchers || []).map((matcher) => ({
      ...matcher,
      name: matcher?.name || matcher?.labelName,
      value: matcher?.value ?? matcher?.labelValue ?? "",
      isRegex: Boolean(matcher?.isRegex),
      isEqual: matcher?.isEqual !== false,
    })),
  }));
};

const ALERT_NAME_LABELS = new Set(["alertname", "rulename"]);

const isSilenceCurrentlyActive = (silence) => {
  const state = silence?.status?.state?.toLowerCase();
  if (state) return state === "active" || state === "pending";
  if (!silence?.startsAt || !silence?.endsAt) return false;

  const now = moment();
  return moment(silence.startsAt).isSameOrBefore(now) && moment(silence.endsAt).isAfter(now);
};

const matcherMatchesCandidate = (matcher, candidate, labelName) => {
  const matcherValue = String(matcher?.value ?? "").trim();
  const candidateValue = String(candidate ?? "").trim();
  if (!matcherValue && !candidateValue) return true;
  const isEqual = matcher?.isEqual !== false;
  const shouldIgnoreCase = ALERT_NAME_LABELS.has(String(labelName || "").toLowerCase());

  if (matcher?.isRegex) {
    try {
      const matched = new RegExp(matcherValue).test(candidateValue);
      return isEqual ? matched : !matched;
    } catch {
      return false;
    }
  }

  const matched =
    candidateValue === matcherValue ||
    (shouldIgnoreCase && candidateValue.toLowerCase() === matcherValue.toLowerCase());
  return isEqual ? matched : !matched;
};

const getAlertMatcherCandidates = (alertOrTitle, labelName) => {
  const alert = typeof alertOrTitle === "string" ? null : alertOrTitle;
  const title = typeof alertOrTitle === "string" ? alertOrTitle : alertOrTitle?.title;
  const firstRule = alert?.data?.[0] || {};
  const normalizedLabelName = String(labelName || "").toLowerCase();
  const candidates = [];

  const addCandidate = (value) => {
    if (value !== undefined && value !== null && String(value).trim() !== "") {
      candidates.push(String(value).trim());
    }
  };

  const labelSources = [alert?.labels, firstRule?.labels];
  labelSources.forEach((labels) => {
    if (!labels || typeof labels !== "object") return;
    Object.entries(labels).forEach(([key, value]) => {
      if (key.toLowerCase() === normalizedLabelName) {
        addCandidate(value);
      }
    });
  });

  if (normalizedLabelName === "alertname" || normalizedLabelName === "rulename") {
    addCandidate(title);
    addCandidate(alert?.name);
    addCandidate(alert?.labels?.alertname);
    addCandidate(alert?.labels?.rulename);
    addCandidate(firstRule?.labels?.alertname);
    addCandidate(firstRule?.labels?.rulename);
    addCandidate(firstRule?.model?.title);
    const alertId = String(alert?.id || "");
    if (alertId.includes("#")) {
      addCandidate(alertId.split("#").pop());
    }
  }

  return [...new Set(candidates)];
};

const getMatcherCandidatesForSilence = (alertOrTitle, matcher) => {
  const labelName = matcher.name || matcher.labelName;
  if (!labelName) return [];

  let candidates = getAlertMatcherCandidates(alertOrTitle, labelName);
  const normalizedLabelName = String(labelName).toLowerCase();

  if (normalizedLabelName === "alertname") {
    candidates = candidates.concat(getAlertMatcherCandidates(alertOrTitle, "rulename"));
  } else if (normalizedLabelName === "rulename") {
    candidates = candidates.concat(getAlertMatcherCandidates(alertOrTitle, "alertname"));
  }

  return [...new Set(candidates)];
};

const findActiveSilenceForAlert = (alertOrTitle, silences = []) => {
  const isAmp =
    alertOrTitle?.platform === AMP_PLATFORM ||
    String(alertOrTitle?.id || "").includes("#");
  const ordered = isAmp
    ? [
        ...(silences || []).filter((silence) => silence.platform === AMP_PLATFORM),
        ...(silences || []).filter((silence) => silence.platform !== AMP_PLATFORM),
      ]
    : [
        ...(silences || []).filter((silence) => !silence.platform || silence.platform === "grafana"),
        ...(silences || []).filter((silence) => silence.platform === AMP_PLATFORM),
      ];

  return ordered.find((silence) => {
    if (!isSilenceCurrentlyActive(silence) || !Array.isArray(silence.matchers) || silence.matchers.length === 0) {
      return false;
    }

    return silence.matchers.every((matcher) => {
      const labelName = matcher.name || matcher.labelName;
      if (!labelName) return false;

      const candidates = getMatcherCandidatesForSilence(alertOrTitle, matcher);
      if (candidates.length === 0) {
        return false;
      }

      return candidates.some((candidate) => matcherMatchesCandidate(matcher, candidate, labelName));
    });
  });
};

const fetchAllSilences = async () => {
  const [grafanaRaw, ampRaw] = await Promise.all([
    alertApi.getSilences().catch(() => []),
    alertApi.getAmpSilences().catch(() => []),
  ]);
  return [
    ...normalizeSilences(grafanaRaw).map((silence) => ({ ...silence, platform: "grafana" })),
    ...normalizeSilences(ampRaw).map((silence) => ({ ...silence, platform: AMP_PLATFORM })),
  ];
};

const isSilenceRecordActionable = (silence) => {
  if (!silence) return false;
  if (silence?.endsAt && moment(silence.endsAt).isBefore(moment())) return false;
  const state = silence?.status?.state?.toLowerCase();
  if (state === "expired") return false;
  return isSilenceCurrentlyActive(silence);
};

const getAlertEvaluationState = (
  d,
  alertTitle,
  firingNamesData,
  pendingNamesData,
  alertId = "",
) => {
  const trimmedTitle = alertTitle ? alertTitle.trim() : "";
  const trimmedId = alertId ? String(alertId).trim() : "";
  const ruleLabels = d.labels || {};
  const ruleRulename = ruleLabels.rulename || ruleLabels.alertname;

  const checkMatch = (name, namesData) => {
    if (!name || !namesData) return false;
    const trimmed = name.trim();
    return (
      (namesData.exact && namesData.exact.has(trimmed)) ||
      (namesData.lower && namesData.lower.has(trimmed.toLowerCase()))
    );
  };

  const checkUidMatch = (id, namesData) => {
    if (!id || !namesData?.uids) return false;
    return namesData.uids.has(id);
  };

  // Prefer firing over pending when both APIs report the same AMP rule.
  if (firingNamesData) {
    if (
      checkUidMatch(trimmedId, firingNamesData) ||
      checkMatch(trimmedTitle, firingNamesData) ||
      checkMatch(ruleRulename, firingNamesData)
    ) {
      return "firing";
    }
    const ruleGroup = d.ruleGroup || ruleLabels.rule_group || ruleLabels.ruleGroup;
    if (ruleGroup && trimmedTitle) {
      const ampKey = `${String(ruleGroup).trim()}#${trimmedTitle}`;
      if (checkUidMatch(ampKey, firingNamesData)) {
        return "firing";
      }
    }
  }

  if (pendingNamesData) {
    if (
      checkUidMatch(trimmedId, pendingNamesData) ||
      checkMatch(trimmedTitle, pendingNamesData) ||
      checkMatch(ruleRulename, pendingNamesData)
    ) {
      return "pending";
    }
    const ruleGroup = d.ruleGroup || ruleLabels.rule_group || ruleLabels.ruleGroup;
    if (ruleGroup && trimmedTitle) {
      const ampKey = `${String(ruleGroup).trim()}#${trimmedTitle}`;
      if (checkUidMatch(ampKey, pendingNamesData)) {
        return "pending";
      }
    }
  }

  if (d.ruleEvaluationState) {
    const ruleState = String(d.ruleEvaluationState).toLowerCase();
    if (ruleState === "active") return "firing";
    if (ruleState === "firing" || ruleState === "pending") return ruleState;
  }

  if (d.state === "firing" || d.status === "firing" || d.status?.state === "firing") {
    return "firing";
  }

  if (Array.isArray(d.data)) {
    const isSomeFiring = d.data.some(
      (item) =>
        item.state === "firing" ||
        item.status === "firing" ||
        item.status?.state === "firing",
    );
    if (isSomeFiring) {
      return "firing";
    }

    const isSomePending = d.data.some(
      (item) =>
        item.state === "pending" ||
        item.status === "pending" ||
        item.status?.state === "pending",
    );
    if (isSomePending) {
      return "pending";
    }
  }

  if (d.labels?.state === "firing") {
    return "firing";
  }
  if (d.labels?.state === "pending") {
    return "pending";
  }

  if (d.state === "pending" || d.status === "pending" || d.status?.state === "pending") {
    return "pending";
  }

  const fallback = d.state || d.status || "normal";
  return fallback === "inactive" ? "normal" : fallback;
};

const resolveAlertDisplayState = (evaluationState, hasActiveSilence) => {
  if (hasActiveSilence) {
    return "suppressed";
  }
  return evaluationState === "inactive" ? "normal" : evaluationState;
};

const applySilenceOverlay = (alert, silences = []) => {
  const matchedSilence = findActiveSilenceForAlert(alert, silences);
  const evaluationState =
    alert.evaluationState ||
    (alert.state === "suppressed" ? "firing" : alert.state) ||
    "normal";

  if (!matchedSilence) {
    return {
      ...alert,
      evaluationState,
      state: resolveAlertDisplayState(evaluationState, false),
      isSilenced: false,
      silenceId: undefined,
    };
  }

  return {
    ...alert,
    evaluationState,
    state: resolveAlertDisplayState(evaluationState, true),
    isSilenced: true,
    silenceId: matchedSilence.id,
    silencePlatform: matchedSilence.platform,
  };
};

const parseDashboardUidFromUrl = (url) => {
  if (!url) return "";
  try {
    const parsed = new URL(url, window.location.origin);
    const parts = parsed.pathname.split("/").filter(Boolean);
    const dIndex = parts.indexOf("d");
    if (dIndex >= 0 && parts[dIndex + 1]) return parts[dIndex + 1];
  } catch {
    // fall through to regex
  }
  const match = String(url).match(/\/d\/([^/?#]+)/);
  return match ? match[1] : "";
};

// ==================== Alert Rules Page ====================
const AlertRulesPage = ({
  silences,
  onSilence,
  onUnsilence,
  onRefreshSilences,
  initialSearchQuery = '',
  initialPlatformFilter = 'all',
  pipelineCreateContext = null,
  onPipelineCreateConsumed = null,
  editAlertName = '',
  onEditAlertConsumed = null,
}) => {
  const navigate = useNavigate();
  const { isDark } = useTheme();
  const { user, accounts, setAccounts } = useAuth();
  const [alerts, setAlerts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [ampSyncing, setAmpSyncing] = useState(false);
  const [titleSuggestions, setTitleSuggestions] = useState([]);
  const [titleSuggestionsLoading, setTitleSuggestionsLoading] = useState(false);
  const titleSuggestionDebounceRef = useRef(null);
  const titleSuggestionRequestIdRef = useRef(0);
  const [firingAlertNames, setFiringAlertNames] = useState(new Set());
  const [pendingAlertNames, setPendingAlertNames] = useState(new Set());
  const [modalVisible, setModalVisible] = useState(false);
  const [editing, setEditing] = useState(null);
  const [expression, setExpression] = useState("");
  const [form] = Form.useForm();
  const [alertCapabilities, setAlertCapabilities] = useState(null);
  const pipelineCreateConsumedRef = useRef(false);
  const editAlertConsumedRef = useRef(false);
  const [seededPipelineLabels, setSeededPipelineLabels] = useState(null);
  const [seededPipelineTitle, setSeededPipelineTitle] = useState("");

  const dataSource = useMemo(() => [
    {
      name: "Metrics",
      value: "prometheus",
    },
    {
      name: "Logs (Loki)",
      value: "loki",
    },
    {
      name: "Co-Relation",
      value: "correlation",
    },
  ], []);
  const [sourceData, setDatasource] = useState("");
  const [selectFields, setSelectFields] = useState([""]);
  const [logsService, setLogsService] = useState([]);
  const [selectedLogSource, setSelectedLogSource] = useState("");
  const [selectedLogSourceValue, setSelectedLogSourceValue] = useState("");
  const [labelOptions, setLabelOptions] = useState({});
  const [active, setActive] = useState(false);
  const isViewer = !IsEnabled("Alerts");
  // const [notificationNames, setNotificationNames] = useState([]);
  // const [selectedNotifationname, setSelectedNotifationname] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [checked, setChecked] = useState(false);
  const [dashboardUid, setDashboardUid] = useState([]);
  const [selectDashboardTitle, setSelectDashboardTitle] = useState("");
  const [query, setQuery] = useState("");
  const [preview, setPreview] = useState("");
  const ampSyncRequestIdRef = useRef(0);

  useEffect(() => {
    if (accounts?.length > 0) return;
    accountService
      .getAccounts()
      .then((data) => {
        if (Array.isArray(data) && data.length > 0) {
          setAccounts(data);
        }
      })
      .catch((err) => {
        console.warn("[AlertRulesPage] Failed to load accounts for lineage RCA", err);
      });
  }, [accounts?.length, setAccounts]);

  const resolveAlertAccount = useCallback(() => {
    const account = accounts?.[0];
    if (!account) return null;
    return {
      clientId: account.clientId || user?.client_id,
      awsAccountId: account.accountId,
    };
  }, [accounts, user?.client_id]);

  const handleAskAIDebugger = useCallback(
    async (alert) => {
      const account = resolveAlertAccount();
      let prompt = buildLineageAwareRcaPrompt(alert, null);
      let model = "auto v1";

      if (account?.clientId && account?.awsAccountId) {
        const lineageContext = await resolveLineageContextForAlert(alert, {
          clientId: account.clientId,
          awsAccountId: account.awsAccountId,
          fetchGraph: (pipelineId, clientId, awsAccountId, hints) =>
            pipelineDiscoveryService.getPipelineLineageGraph(
              pipelineId,
              clientId,
              awsAccountId,
              hints,
            ),
        });
        if (lineageContext?.graph) {
          prompt = buildLineageAwareRcaPrompt(alert, lineageContext.graph);
          model = "rca-v1";
        }
      }

      navigate("/aiDebugger", {
        state: { prompt, model },
      });
    },
    [navigate, resolveAlertAccount],
  );
  const [notificationNames, setNotificationNames] = useState([]);
  const [selectedNotifationname, setSelectedNotifationname] = useState([]);
  const [currentStep, setCurrentStep] = useState(0);
  const [metricsData, setMetricsData] = useState([]);
  const [metricsLoading, setMetricsLoading] = useState(false);

  //added quick templates over here
  // Quick alert templates
  const alertTemplates = [
    {
      title: 'High CPU Usage',
      description: 'Triggers when CPU exceeds threshold',
      dataSource: 'prometheus',
      expression: 'node_cpu_seconds_total',
      notificationChannels: notificationNames[0] || '',
      relativeFrom: 300,
      relativeTo: 0,
    },
    {
      title: 'High Memory Usage',
      description: 'Triggers when memory is low',
      dataSource: 'prometheus',
      expression: 'node_memory_MemAvailable_bytes',
      notificationChannels: notificationNames[0] || '',
      relativeFrom: 300,
      relativeTo: 0,
    },
    {
      title: 'Service Down',
      description: 'Triggers when service is unreachable',
      dataSource: 'prometheus',
      expression: 'up{job="myservice"}',
      notificationChannels: notificationNames[0] || '',
      relativeFrom: 300,
      relativeTo: 0,
    },
  ];

  // Function to apply template
  const applyTemplate = (template) => {
    form.setFieldsValue({
      title: template.title,
      dataSource: template.dataSource,
      notificationChannels: template.notificationChannels,
      relativeFrom: template.relativeFrom,
      relativeTo: template.relativeTo,
    });
    setDatasource(template.dataSource);
    setExpression(template.expression);
    message.success(`Applied template: ${template.title}`);
  };

  const getNotificationNames = async () => {
    alertApi
      .getNotificationNames()
      .then((res) => {
        const names = (res.receivers || []).map((r) => r.name);
        setNotificationNames(names);
        setLoading(false);
      })
      .catch(() => {
        message.error("Failed to load metrics configuration");
        setLoading(false);
      });
  };

  const getDashboardUIDs = async () => {
    alertApi
      .getAllDashBoardsUid()
      .then((res) => {
        const dashboardTitle = res.dashboards;
        setDashboardUid(dashboardTitle);
        setLoading(false);
      })
      .catch(() => {
        message.error("Failed to load metrics configuration");
        setLoading(false);
      });
  };

const handleDashboardSelect = (value) => {
  setSelectDashboardTitle(value);
};

  const handleCheckboxChange = (e) => {
    const isChecked = e.target.checked;
    setChecked(isChecked);
    setSelectDashboardTitle("");
    if (isChecked) {
      setIsModalVisible(true); // show popup when checked
    }
  };

  const handleModalOk = () => {
    setIsModalVisible(false);
  };

  const handleModalCancel = () => {
    setSelectDashboardTitle("");    setIsModalVisible(false);
    setChecked(false); // uncheck if canceled
  };

  // Helper function to extract alert name from firing alert (matches FiringAlertsList logic)
  const getAlertNameFromFiringAlert = (alert) => {
    const labels = alert.labels || {};
    
    // If name is the literal string "alertname" or "rulename", extract from labels
    if (alert.name === 'alertname' || alert.name === 'rulename') {
      // Try rulename first, then alertname
      return labels.rulename || labels.alertname || null;
    }
    
    // If name field exists and is not empty, use it (it might already be the alert name)
    if (alert.name && alert.name.trim() !== '' && alert.name !== 'alertname' && alert.name !== 'rulename') {
      return alert.name;
    }
    
    // Fallback to labels - check both rulename and alertname
    return labels.rulename || labels.alertname || null;
  };

  const FIRING_EVALUATION_STATES = new Set(["firing", "active", "error", "nodata"]);
  const EMPTY_ACTIVE_STATE_SETS = {
    exact: new Set(),
    lower: new Set(),
    uids: new Set(),
  };

  const buildProcessedAlerts = (data, firingNamesData, pendingNamesData, silencesList) =>
    Object.entries(data || {}).map(([title, d]) => {
      const displayTitle = d.title || title;
      const firstRule = (d.data || [])[0] || {};
      const rel = firstRule.relativeTimeRange || {};
      const evaluationState = getAlertEvaluationState(
        d,
        displayTitle,
        firingNamesData,
        pendingNamesData,
        d.alert_id,
      );
      const silenceMatch = findActiveSilenceForAlert(
        {
          title: displayTitle,
          labels: d.labels || {},
          data: d.data || [],
        },
        silencesList,
      );
      const alertState = resolveAlertDisplayState(
        evaluationState,
        Boolean(silenceMatch),
      );
      const ruleLabels = d.labels || {};
      const alertSeverity = (d.severity || ruleLabels.severity || "warning").toLowerCase();
      const { threshold, operator } = getGrafanaThresholdInfo({
        data: d.data || [],
        condition: d.condition,
        threshold_value: d.threshold_value,
        operator: d.operator,
      });

      return {
        platform: "grafana",
        title: displayTitle,
        id: d.alert_id,
        data: d.data || [],
        condition: d.condition,
        notificationChannels: d.notificationChannels || [],
        enabled: d.enabled,
        labels: ruleLabels,
        evaluationState,
        state: alertState,
        isSilenced: Boolean(silenceMatch),
        silenceId: silenceMatch?.id,
        silencePlatform: silenceMatch?.platform,
        viewData:
          d.explorer?.["View Data"] ||
          d.explorer?.["View Data (Prometheus)"] ||
          d.explorer?.["View Data (Loki)"] ||
          d.explorer?.ExploreMetricsURL ||
          d.explorer?.ExploreLogsURL ||
          "",
        viewDashboard: d.explorer?.Dashboard,
        lastTriggered: d.lastTriggered || d.last_triggered || "Never",
        triggerCount: d.triggerCount || d.trigger_count || 0,
        threshold_value: threshold,
        severity: alertSeverity,
        operator,
        for_duration: d.for_duration || d.for || "",
        relativeFrom: rel.from ?? d.relativeFrom,
        relativeTo: rel.to ?? d.relativeTo,
      };
    });

  const buildOptimisticAmpAlert = (ampPayload, alertId, fallbackExisting) => {
    const optimisticItem = {
      alert_id: alertId || fallbackExisting?.id || `${ampPayload.group}#${ampPayload.alertName}`,
      alert_name: ampPayload.alertName,
      group_name: ampPayload.group,
      expression: ampPayload.expression,
      duration: ampPayload.duration,
      severity: ampPayload.severity,
      labels: ampPayload.labels || {},
      annotations: ampPayload.annotations || {},
      receiver: ampPayload.receiver,
      status: "ACTIVE",
      rule_evaluation_state: fallbackExisting?.ruleEvaluationState || "pending",
    };
    const normalized = normalizeAmpAlert(optimisticItem);
    return normalized ? applySilenceOverlay(normalized, silences) : null;
  };

  // Grafana pending lives on the Prometheus alerts API, not Alertmanager.
  const addActiveAlertToSets = (alert, state, sets) => {
    const alertName = getAlertNameFromFiringAlert(alert);
    const ruleUid =
      alert.alert_rule_uid ||
      alert.labels?.__alert_rule_uid__ ||
      alert.labels?.rule_uid ||
      alert.labels?.alertRuleUID;
    if (alertName) {
      const trimmedName = alertName.trim();
      sets.names.add(trimmedName);
      sets.namesLower.add(trimmedName.toLowerCase());
    }
    if (ruleUid) {
      sets.uids.add(String(ruleUid).trim());
    }
    const ruleGroup =
      alert.rule_group ||
      alert.labels?.rule_group ||
      alert.labels?.ruleGroup;
    if (ruleGroup && alertName) {
      sets.uids.add(`${String(ruleGroup).trim()}#${alertName.trim()}`);
    }
  };

  const loadActiveAlertStates = async () => {
    const emptySet = new Set();
    const empty = { exact: emptySet, lower: emptySet, uids: emptySet };

    try {
      const response = await alertApi.getFiringAlerts();
      const firingSets = { names: new Set(), namesLower: new Set(), uids: new Set() };
      const pendingSets = { names: new Set(), namesLower: new Set(), uids: new Set() };

      if (response.status === "success" && Array.isArray(response.alerts)) {
        response.alerts.forEach((alert) => {
          const state = String(alert.state || "").toLowerCase();
          if (FIRING_EVALUATION_STATES.has(state)) {
            addActiveAlertToSets(alert, state, firingSets);
          }
        });
        response.alerts.forEach((alert) => {
          const state = String(alert.state || "").toLowerCase();
          if (state !== "pending") return;
          const ruleUid = String(
            alert.alert_rule_uid ||
              alert.labels?.__alert_rule_uid__ ||
              alert.labels?.rule_uid ||
              "",
          ).trim();
          const alertName = getAlertNameFromFiringAlert(alert);
          if (ruleUid && firingSets.uids.has(ruleUid)) return;
          if (alertName && firingSets.names.has(alertName.trim())) return;
          const ruleGroup =
            alert.rule_group || alert.labels?.rule_group || alert.labels?.ruleGroup;
          if (ruleGroup && alertName) {
            const ampKey = `${String(ruleGroup).trim()}#${alertName.trim()}`;
            if (firingSets.uids.has(ampKey)) return;
          }
          addActiveAlertToSets(alert, state, pendingSets);
        });
      }

      const firingNames = firingSets.names;
      const pendingNames = pendingSets.names;
      console.log("Firing alert names loaded:", Array.from(firingNames));
      console.log("Firing alert uids loaded:", Array.from(firingSets.uids));
      console.log("Pending alert names loaded:", Array.from(pendingNames));
      console.log("Pending alert uids loaded:", Array.from(pendingSets.uids));
      setFiringAlertNames(firingNames);
      setPendingAlertNames(pendingNames);
      return {
        firing: {
          exact: firingNames,
          lower: firingSets.namesLower,
          uids: firingSets.uids,
        },
        pending: {
          exact: pendingNames,
          lower: pendingSets.namesLower,
          uids: pendingSets.uids,
        },
      };
    } catch (err) {
      console.error("Error fetching active alert states:", err);
      setFiringAlertNames(emptySet);
      setPendingAlertNames(emptySet);
      return { firing: empty, pending: empty };
    }
  };

  // Helper function to determine alert status from multiple sources
  const getAlertState = (
    d,
    alertTitle,
    firingNamesData,
    pendingNamesData,
    silencesList = [],
    alertId = "",
  ) => {
    const trimmedTitle = alertTitle ? alertTitle.trim() : "";
    const evaluationState = getAlertEvaluationState(
      d,
      trimmedTitle,
      firingNamesData,
      pendingNamesData,
      alertId,
    );
    const silenceMatch = findActiveSilenceForAlert(
      {
        title: trimmedTitle,
        labels: d.labels || {},
        data: d.data || [],
      },
      silencesList,
    );
    return resolveAlertDisplayState(evaluationState, Boolean(silenceMatch));
  };

  const refreshAlertStates = async () => {
    try {
      const { firing: firingNamesData, pending: pendingNamesData } =
        await loadActiveAlertStates();
      setAlerts((prev) => {
        if (!prev.length) return prev;
        return prev.map((alert) => {
          if (alert.platform === AMP_PLATFORM) {
            const deployStatus = String(alert.ampDeployStatus || '').toUpperCase();
            if (deployStatus !== 'ACTIVE') {
              return alert;
            }
          }
          const evaluationState = getAlertEvaluationState(
            {
              labels: alert.labels || {},
              data: alert.data || [],
              ruleGroup: alert.ruleGroup,
              ruleEvaluationState: alert.ruleEvaluationState,
            },
            alert.title,
            firingNamesData,
            pendingNamesData,
            alert.id,
          );
          const silenceMatch = findActiveSilenceForAlert(
            {
              platform: alert.platform,
              id: alert.id,
              title: alert.title,
              labels: alert.labels || {},
              data: alert.data || [],
              ruleGroup: alert.ruleGroup,
            },
            silences,
          );
          return {
            ...alert,
            evaluationState,
            state: resolveAlertDisplayState(evaluationState, Boolean(silenceMatch)),
            isSilenced: Boolean(silenceMatch),
            silenceId: silenceMatch?.id,
            silencePlatform: silenceMatch?.platform,
          };
        });
      });
      const firingCount = firingNamesData?.exact?.size ?? 0;
      const pendingCount = pendingNamesData?.exact?.size ?? 0;
      console.log(
        `Alert states refreshed — firing names: ${firingCount}, pending names: ${pendingCount}`,
      );
    } catch (err) {
      console.warn("Failed to refresh alert states (rules still visible):", err);
    }
  };

  const loadAlerts = async (options = {}) => {
    const { skipAmpBackgroundSync = false } = options;
    setLoading(true);
    try {
      const [grafanaResult, ampResult] = await Promise.allSettled([
        alertApi.getAlerts(),
        alertApi.getAmpAlerts({ syncFromAmp: false }),
      ]);
      const grafanaData = grafanaResult.status === "fulfilled" ? grafanaResult.value : {};
      const ampResponse = ampResult.status === "fulfilled"
        ? ampResult.value
        : { alerts: [], sync_info: { errors: [{ error: ampResult.reason?.message || "fetch failed" }] } };

      if (grafanaResult.status === "rejected") {
        console.warn("Grafana alerts fetch failed:", grafanaResult.reason);
        message.warning(`Grafana alerts could not be loaded: ${grafanaResult.reason?.message || "Unknown error"}`);
      }
      if (ampResult.status === "rejected") {
        console.warn("AMP alerts fetch failed:", ampResult.reason);
        message.warning(`AMP alerts could not be loaded: ${ampResult.reason?.message || "Unknown error"}`);
      }

      const processedGrafana = buildProcessedAlerts(
        grafanaData,
        EMPTY_ACTIVE_STATE_SETS,
        EMPTY_ACTIVE_STATE_SETS,
        silences,
      );

      const processedAmp = (ampResponse?.alerts || [])
        .map(normalizeAmpAlert)
        .filter(Boolean)
        .map((alert) => applySilenceOverlay(alert, silences));

      const syncInfo = ampResponse?.sync_info;
      if (syncInfo?.errors?.length && processedAmp.length === 0) {
        const syncError = syncInfo.errors[0]?.error || syncInfo.errors[0]?.message;
        if (syncError) {
          message.warning(`AMP sync: ${syncError}`, 8);
        }
      } else if ((syncInfo?.imported || 0) > 0) {
        message.success(`Imported ${syncInfo.imported} AMP alert(s) from workspace`);
      } else if (
        (syncInfo?.total_in_amp || 0) > 0 &&
        processedAmp.length === 0
      ) {
        message.warning(
          "AMP workspace has rules but none were loaded. Check backend logs and DynamoDB permissions.",
          6,
        );
      } else if (syncInfo?.errors?.length) {
        const syncError = syncInfo.errors
          .map((entry) => entry?.error || entry?.message)
          .filter(Boolean)
          .join("; ");
        const isTransientAlertmanagerSync =
          /UPDATING|ConflictException|alertmanager_updating|alertmanager_conflict/i.test(syncError);
        if (/alertmanager/i.test(syncError) && !isTransientAlertmanagerSync) {
          message.warning(
            `AMP Teams routing is not synced (${syncError}). Notifications may not reach Teams until Alertmanager is synced.`,
            10,
          );
        } else if (!isTransientAlertmanagerSync) {
          console.warn("AMP workspace sync could not refresh rules (showing cached AMP alerts):", syncInfo);
        }
      }

      setAlerts([...processedGrafana, ...processedAmp]);
      console.log(
        `Loaded ${processedGrafana.length} Grafana and ${processedAmp.length} AMP alert rule(s)`,
        syncInfo ? { ampSync: syncInfo } : null,
      );

      if (!skipAmpBackgroundSync) {
        // Non-blocking AMP workspace sync: keeps UI fast while refreshing AMP cache in background.
        const syncRequestId = ++ampSyncRequestIdRef.current;
        setAmpSyncing(true);
        alertApi
          .getAmpAlerts({ syncFromAmp: true, timeoutMs: 120000 })
          .then((syncResponse) => {
            if (syncRequestId !== ampSyncRequestIdRef.current) return;
            const syncedAmp = (syncResponse?.alerts || [])
              .map(normalizeAmpAlert)
              .filter(Boolean)
              .map((alert) => applySilenceOverlay(alert, silences));
            setAlerts((prev) => {
              const nonAmp = prev.filter((alert) => alert.platform !== AMP_PLATFORM);
              if (!syncedAmp.length) {
                const existingAmp = prev.filter((alert) => alert.platform === AMP_PLATFORM);
                if (existingAmp.length > 0) {
                  console.warn(
                    "AMP background sync returned no rules; keeping cached AMP alerts",
                  );
                  return prev;
                }
              }
              return [...nonAmp, ...syncedAmp];
            });
          })
          .catch((err) => {
            if (syncRequestId !== ampSyncRequestIdRef.current) return;
            console.warn("AMP background sync failed:", err);
          })
          .finally(() => {
            if (syncRequestId === ampSyncRequestIdRef.current) {
              setAmpSyncing(false);
            }
          });
      }
    } catch (err) {
      message.error(`Failed to load alerts: ${err.message || "Unknown error"}`);
    } finally {
      setLoading(false);
    }

    refreshAlertStates();
  };
  const loadAlertsRef = useRef(loadAlerts);
  loadAlertsRef.current = loadAlerts;
  const refreshAlertStatesRef = useRef(refreshAlertStates);
  refreshAlertStatesRef.current = refreshAlertStates;
  const logsLoadedRef = useRef(null);
  const ensureLogsLoaded = () => {
    const account = resolveAlertAccount();
    const accountKey =
      account?.clientId && account?.awsAccountId
        ? `${account.clientId}:${account.awsAccountId}`
        : "global";
    if (logsLoadedRef.current === accountKey) return;
    logsLoadedRef.current = accountKey;
    loadLogs();
  };

  // Deep-link from Pipeline Discovery: /alerts?create=1&pipelineId=...
  useEffect(() => {
    if (!pipelineCreateContext?.pipelineId || pipelineCreateConsumedRef.current) {
      return;
    }
    pipelineCreateConsumedRef.current = true;
    const labels = {
      pipeline_id: pipelineCreateContext.pipelineId,
      ...(pipelineCreateContext.pipelineName
        ? { pipeline_name: pipelineCreateContext.pipelineName }
        : {}),
      ...(pipelineCreateContext.pipelineType
        ? { pipeline_type: pipelineCreateContext.pipelineType }
        : {}),
    };
    setSeededPipelineLabels(labels);
    setSeededPipelineTitle(
      pipelineCreateContext.pipelineName
        ? `${pipelineCreateContext.pipelineName} alert`
        : "",
    );
    setEditing(null);
    setTitleSuggestions([]);
    setTitleSuggestionsLoading(false);
    setSelectDashboardTitle("");
    form.resetFields();
    form.setFieldsValue({
      relativeFrom: 300,
      relativeTo: 0,
      ruleGroup: "app-alerts",
      title: pipelineCreateContext.pipelineName
        ? `${pipelineCreateContext.pipelineName} alert`
        : undefined,
      extraLabels: labels,
    });
    ensureLogsLoaded();
    setDatasource("");
    setModalVisible(true);
    onPipelineCreateConsumed?.();
  }, [pipelineCreateContext, form, onPipelineCreateConsumed]);

  // Deep-link from Pipeline Discovery: /alerts?create=1&pipelineId=...
  useEffect(() => {
    if (!pipelineCreateContext?.pipelineId || pipelineCreateConsumedRef.current) {
      return;
    }
    pipelineCreateConsumedRef.current = true;
    const labels = {
      pipeline_id: pipelineCreateContext.pipelineId,
      ...(pipelineCreateContext.pipelineName
        ? { pipeline_name: pipelineCreateContext.pipelineName }
        : {}),
      ...(pipelineCreateContext.pipelineType
        ? { pipeline_type: pipelineCreateContext.pipelineType }
        : {}),
    };
    setSeededPipelineLabels(labels);
    setSeededPipelineTitle(
      pipelineCreateContext.pipelineName
        ? `${pipelineCreateContext.pipelineName} alert`
        : "",
    );
    setEditing(null);
    setTitleSuggestions([]);
    setTitleSuggestionsLoading(false);
    setSelectDashboardTitle("");
    form.resetFields();
    form.setFieldsValue({
      relativeFrom: 300,
      relativeTo: 0,
      ruleGroup: "app-alerts",
      title: pipelineCreateContext.pipelineName
        ? `${pipelineCreateContext.pipelineName} alert`
        : undefined,
      extraLabels: labels,
    });
    ensureLogsLoaded();
    setDatasource("");
    setModalVisible(true);
    onPipelineCreateConsumed?.();
  }, [pipelineCreateContext, form, onPipelineCreateConsumed]);

  const loadLogs = async () => {
    const applyLabels = (logsData) => {
      const { keys, options } = normalizeLokiLabelsResponse(logsData);
      setLabelOptions(options);
      setLogsService(keys);
    };

    const account = resolveAlertAccount();
    const logParams = {
      clientId: account?.clientId,
      awsAccountId: account?.awsAccountId,
    };

    try {
      // Fast path: label names only (populates dropdown quickly)
      const keysData = await alertApi.getAlertPageLogs({
        keysOnly: true,
        timeoutMs: 15000,
        ...logParams,
      });
      applyLabels(keysData);

      // Full path: label values for value autocomplete (background)
      try {
        const fullData = await alertApi.getAlertPageLogs({
          keysOnly: false,
          timeoutMs: 60000,
          ...logParams,
        });
        applyLabels(fullData);
      } catch (valuesErr) {
        console.warn('Loki label values unavailable; label names loaded:', valuesErr);
      }
    } catch (err) {
      console.warn('Could not load Loki labels for LogQL builder:', err);
      message.warning('Loki labels unavailable — LogQL builder will have limited autocomplete. Check Grafana/Loki connectivity.');
      setLabelOptions({});
      setLogsService([]);
    }
  };

  const onAlertTitleInput = useCallback((title) => {
    if (titleSuggestionDebounceRef.current) {
      clearTimeout(titleSuggestionDebounceRef.current);
    }

    const cleanTitle = String(title || "").trim();
    if (cleanTitle.length < 3 || !/[a-zA-Z]/.test(cleanTitle)) {
      setTitleSuggestions([]);
      setTitleSuggestionsLoading(false);
      return;
    }

    // Clear stale suggestions and show loading immediately while typing.
    setTitleSuggestions([]);
    setTitleSuggestionsLoading(true);

    titleSuggestionDebounceRef.current = setTimeout(async () => {
      const requestId = ++titleSuggestionRequestIdRef.current;
      try {
        const data = await alertApi.getIntelligentAlertSuggestions({
          title: cleanTitle,
          maxSuggestions: 8,
        });
        if (requestId !== titleSuggestionRequestIdRef.current) {
          return;
        }
        const next = Array.isArray(data?.suggestions) ? data.suggestions : [];
        setTitleSuggestions(next.slice(0, 5));
      } catch (err) {
        if (requestId !== titleSuggestionRequestIdRef.current) {
          return;
        }
        console.error("Failed to load intelligent title suggestions:", err);
        setTitleSuggestions([]);
      } finally {
        if (requestId === titleSuggestionRequestIdRef.current) {
          setTitleSuggestionsLoading(false);
        }
      }
    }, 350);
  }, []);

  useEffect(() => {
    loadAlerts();
    onRefreshSilences?.();
    getNotificationNames();
    getDashboardUIDs();
    alertApi.getAlertCapabilities()
      .then(setAlertCapabilities)
      .catch((err) => {
        console.warn("Failed to load alert capabilities:", err);
      });
    alertApi.getAlertCapabilities()
      .then(setAlertCapabilities)
      .catch((err) => {
        console.warn("Failed to load alert capabilities:", err);
      });
    const interval = setInterval(() => {
      refreshAlertStatesRef.current();
      onRefreshSilences?.();
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (alerts.length === 0) return;

    const wasSilenced = alerts.some(
      (alert) => alert.isSilenced || alert.state === "suppressed" || alert.state === "silenced"
    );
    const nextAlerts = alerts.map((alert) => applySilenceOverlay(alert, silences));
    const stillSilenced = nextAlerts.some(
      (alert) => alert.isSilenced || alert.state === "suppressed" || alert.state === "silenced"
    );

    if (wasSilenced && !stillSilenced) {
      loadAlertsRef.current();
      return;
    }

    setAlerts(nextAlerts);
  }, [silences]);

  useEffect(() => {
    if (!modalVisible) {
      setCurrentStep(0); // Reset when modal closes
      return;
    }

    const values = form.getFieldsValue();
    
    // Step 1: Basic Info (title, dataSource, channels)
    if (values.title && values.dataSource && values.notificationChannels) {
      setCurrentStep(1);
      
      // Step 2: Condition (expression exists)
      if (expression) {
        setCurrentStep(2);
      }
    } else {
      setCurrentStep(0);
    }
  }, [modalVisible, form, expression]);

  const onExprChange = useCallback((expr) => setExpression(expr), []);

  const getQueryRule = (alertData = []) => {
    return alertData.find((item) => item?.model?.expr) || alertData[0] || {};
  };

  const getQueryRuleByType = (alertData = [], type) => {
    return alertData.find((item) => item?.model?.datasource?.type === type && item?.model?.expr) || {};
  };

  const getDataSourceFromAlertData = (alertData = [], fallback) => {
    if (fallback) return fallback;

    const hasPrometheus = alertData.some((item) => item?.model?.datasource?.type === 'prometheus' && item?.model?.expr);
    const hasLoki = alertData.some((item) => item?.model?.datasource?.type === 'loki' && item?.model?.expr);
    if (hasPrometheus && hasLoki) return 'correlation';
    if (hasPrometheus) return 'prometheus';
    if (hasLoki) return 'loki';

    return '';
  };

  const getThresholdRule = (alertData = [], conditionRefId) => {
    const hasThresholdValue = (item) => {
      const params = item?.model?.conditions?.[0]?.evaluator?.params;
      return Array.isArray(params) && params.length > 0;
    };

    return alertData.find((item) => item?.refId === conditionRefId && hasThresholdValue(item)) ||
      alertData.find((item) => item?.model?.refId === conditionRefId && hasThresholdValue(item)) ||
      alertData.find((item) => item?.model?.type === 'threshold' && hasThresholdValue(item)) ||
      alertData.find(hasThresholdValue) ||
      {};
  };

  const getThresholdFromRule = (alertData = [], fallback, conditionRefId) => {
    if (fallback !== undefined && fallback !== null && fallback !== '') {
      return fallback;
    }

    const params = getThresholdRule(alertData, conditionRefId)?.model?.conditions?.[0]?.evaluator?.params;
    return Array.isArray(params) && params.length > 0 ? params[0] : 0;
  };

  const getOperatorFromRule = (alertData = [], fallback, conditionRefId) => {
    if (fallback) return fallback;

    const evaluatorType = getThresholdRule(alertData, conditionRefId)?.model?.conditions?.[0]?.evaluator?.type;
    const operatorMap = {
      gt: '>',
      gte: '>=',
      lt: '<',
      lte: '<=',
      eq: '==',
    };

    return operatorMap[evaluatorType] || '>';
  };

  const onEdit = (rec) => {
    setEditing(rec);

    if (rec.platform === AMP_PLATFORM) {
      const { metricExpr, operator, threshold } = parseAmpExpressionParts(rec.expression);
      const savedExpr = metricExpr || rec.expression || "";
      const channels = Array.isArray(rec.notificationChannels)
        ? rec.notificationChannels
        : (rec.notificationChannels ? [rec.notificationChannels] : []);
      const savedDescription = rec.annotations?.description || rec.annotations?.summary || "";
      const dashboardUrl =
        rec.viewDashboard ||
        rec.annotations?.Dashboard ||
        "";
      const dashboardUidFromUrl = parseDashboardUidFromUrl(dashboardUrl);

      setExpression(savedExpr);
      setDatasource("prometheus");
      setSelectDashboardTitle(dashboardUidFromUrl || "");
      form.setFieldsValue({
        title: rec.title,
        description: savedDescription,
        dataSource: "prometheus",
        alertPlatform: AMP_PLATFORM,
        ruleGroup: rec.ruleGroup || "app-alerts",
        notificationChannels: channels,
        relativeFrom: rec.relativeFrom ?? 300,
        relativeTo: 0,
        threshold,
        severity: rec.severity || "warning",
        operator,
        includeDashboard: Boolean(dashboardUidFromUrl || dashboardUrl),
        viewData: Boolean(rec.viewData),
        dashboard_uid: dashboardUidFromUrl || undefined,
      });
      setModalVisible(true);
      return;
    }

    const alertData = rec.data || [];
    const r = getQueryRule(alertData);
    const dataSource = getDataSourceFromAlertData(alertData, rec.dataSource);
    const promRule = getQueryRuleByType(alertData, 'prometheus');
    const logRule = getQueryRuleByType(alertData, 'loki');
    const savedPromExpr = promRule?.model?.expr || '';
    const savedLogExpr = logRule?.model?.expr || '';
    const savedExpr = dataSource === 'correlation' ? (savedPromExpr || savedLogExpr) : (r.model?.expr || '');
    const threshold = getThresholdFromRule(alertData, rec.threshold_value, rec.condition);
    const operator = getOperatorFromRule(alertData, rec.operator, rec.condition);

    setExpression(savedExpr);
    setDatasource(dataSource);
    if (rec.viewDashboard != null && rec.viewDashboard != "") {
      const url = rec.viewDashboard;
      const dashboardUidFromUrl = parseDashboardUidFromUrl(url);
      if (dashboardUidFromUrl) {
        setSelectDashboardTitle(dashboardUidFromUrl);
      } else {
        setSelectDashboardTitle("");
      }
    } else {
      setSelectDashboardTitle('');
    }
    const channels = Array.isArray(rec.notificationChannels) ? rec.notificationChannels : (rec.notificationChannels ? [rec.notificationChannels] : []);
    form.setFieldsValue({
      title: rec.title,
      description: rec.annotations?.description || '',
      dataSource,
      notificationChannels: channels,
      relativeFrom: rec.relativeFrom ?? r.relativeTimeRange?.from ?? 300,
      relativeTo: rec.relativeTo ?? r.relativeTimeRange?.to ?? 0,
      threshold,
      severity: rec.severity || 'warning',
      operator,
      prom_expr: savedPromExpr || savedExpr,
      log_expr: savedLogExpr || savedExpr,
      includeDashboard: rec.viewDashboard != null && rec.viewDashboard !== '',
      viewData: rec.viewData != null && rec.viewData !== '',
    });
    ensureLogsLoaded();
    setModalVisible(true);
  };

  const onDelete = async (rec) => {
    setLoading(true);
    try {
      if (rec.platform === AMP_PLATFORM) {
        await alertApi.deleteAmpAlert(rec.id);
      } else {
        await alertApi.deleteAlert(rec.id);
      }
      message.success("Alert deleted successfully");
      await loadAlerts();
    } catch (err) {
      message.error(err?.message || "Failed to delete alert");
    } finally {
      setLoading(false);
    }
  };

  const secondsToForDuration = (seconds) => {
    if (seconds == null || seconds === undefined) return "5m";
    const s = Number(seconds);
    if (s >= 3600) return `${Math.floor(s / 3600)}h`;
    if (s >= 60) return `${Math.floor(s / 60)}m`;
    return `${s}s`;
  };

  const mergeSavedAlertIntoList = useCallback((savedAlert, originalAlert) => {
    if (!savedAlert) return;

    setAlerts((prev) => {
      const matchIndex = prev.findIndex((alert) =>
        alert.id === savedAlert.id ||
        alert.title === savedAlert.title ||
        (originalAlert && (alert.id === originalAlert.id || alert.title === originalAlert.title))
      );

      if (matchIndex === -1) {
        return [savedAlert, ...prev];
      }

      const next = [...prev];
      next[matchIndex] = {
        ...next[matchIndex],
        ...savedAlert,
        labels: {
          ...(next[matchIndex].labels || {}),
          ...(savedAlert.labels || {}),
        },
      };
      return next;
    });
  }, []);

  const onSubmit = useCallback(async (vals) => {
    const operatorToThresholdOp = (op) => {
      const map = { '>': 'gt', '>=': 'gte', '<': 'lt', '<=': 'lte', '==': 'eq' };
      return map[op] || 'gt';
    };
    const thresholdNum = parseFloat(vals.threshold);
    const resolvedThreshold = Number.isFinite(thresholdNum) ? thresholdNum : 0;
    // New alerts always go through Grafana create API; server places metrics in AMP when needed.
    // Existing AMP edits still use the AMP update API.
    const isAmpPlatform = editing?.platform === AMP_PLATFORM;
    const isCorrelation = vals.dataSource === "correlation";
    const promExpr = isCorrelation
      ? vals.promExpression
      : (vals.dataSource === "prometheus" || isAmpPlatform ? vals.expression || expression : "");
    const logExpr = isCorrelation ? vals.logExpression : (vals.dataSource === "loki" ? vals.expression || expression : "");

    if (isAmpPlatform) {
      if (!promExpr) {
        return message.error("PromQL query expression is required");
      }
      const receiver = Array.isArray(vals.notificationChannels)
        ? vals.notificationChannels[0]
        : vals.notificationChannels;
      if (!receiver) {
        return message.error("Notification channel is required");
      }
      setLoading(true);
      try {
        const account = resolveAlertAccount();
        const valsWithDashboard = {
          ...vals,
          dashboard_uid:
            vals.dashboard_uid ||
            selectDashboardTitle ||
            parseDashboardUidFromUrl(editing?.viewDashboard || editing?.annotations?.Dashboard || "") ||
            "",
        };
        const ampPayload = buildAmpAlertPayload(
          valsWithDashboard,
          promExpr,
          account?.awsAccountId,
        );
        // Keep previously saved Dashboard annotation if Include Dashboard is on but UID wasn't restored in UI.
        if (
          vals.includeDashboard &&
          !ampPayload.annotations?.Dashboard &&
          (editing?.viewDashboard || editing?.annotations?.Dashboard)
        ) {
          ampPayload.annotations = {
            ...(ampPayload.annotations || {}),
            Dashboard: editing.viewDashboard || editing.annotations.Dashboard,
          };
        }
        // Clearing checkbox should remove Dashboard / View Data on update.
        if (!vals.includeDashboard && ampPayload.annotations) {
          delete ampPayload.annotations.Dashboard;
        }
        if (!vals.viewData && ampPayload.annotations) {
          delete ampPayload.annotations["View Data"];
          delete ampPayload.annotations["View Data (Prometheus)"];
          delete ampPayload.annotations["View Data (Loki)"];
          delete ampPayload.annotations.ExploreMetricsURL;
          delete ampPayload.annotations.ExploreLogsURL;
        }
        const optimisticAlert = buildOptimisticAmpAlert(
          ampPayload,
          editing?.id,
          editing,
        );
        if (optimisticAlert) {
          setAlerts((prev) => {
            const next = [...prev];
            const idx = next.findIndex(
              (a) =>
                a.platform === AMP_PLATFORM &&
                (a.id === optimisticAlert.id || a.title === optimisticAlert.title),
            );
            if (idx >= 0) next[idx] = { ...next[idx], ...optimisticAlert };
            else next.unshift(optimisticAlert);
            return next;
          });
        }
        if (editing?.platform === AMP_PLATFORM && editing?.id) {
          const editingId = editing.id;
          // Close modal immediately — API + AMP redeploy continue in background.
          setModalVisible(false);
          form.resetFields();
          setExpression("");
          setSelectDashboardTitle("");
          setEditing(null);
          setLoading(false);
          message.success("AMP alert updated — deploying to AMP in background");
          alertApi
            .updateAmpAlert(editingId, ampPayload)
            .then((updateResp) => {
              if (optimisticAlert && updateResp?.alert_id) {
                setAlerts((prev) =>
                  prev.map((a) =>
                    a.platform === AMP_PLATFORM && a.id === optimisticAlert.id
                      ? { ...a, id: updateResp.alert_id }
                      : a,
                  ),
                );
              }
              loadAlertsRef.current({ skipAmpBackgroundSync: true });
              alertApi.getAlertCapabilities().then(setAlertCapabilities).catch(() => {});
            })
            .catch((err) => {
              message.error(err?.message || "Failed to save AMP alert");
              loadAlertsRef.current({ skipAmpBackgroundSync: true });
            });
        } else {
          setModalVisible(false);
          form.resetFields();
          setExpression("");
          setSelectDashboardTitle("");
          setEditing(null);
          setLoading(false);
          message.success("AMP alert created — deploying to AMP in background");
          alertApi
            .createAmpAlert(ampPayload)
            .then((createResp) => {
              if (optimisticAlert && createResp?.alert_id) {
                setAlerts((prev) =>
                  prev.map((a) =>
                    a.platform === AMP_PLATFORM &&
                    (a.id === optimisticAlert.id || a.title === optimisticAlert.title)
                      ? { ...a, id: createResp.alert_id }
                      : a,
                  ),
                );
              }
              loadAlertsRef.current({ skipAmpBackgroundSync: true });
              alertApi.getAlertCapabilities().then(setAlertCapabilities).catch(() => {});
            })
            .catch((err) => {
              message.error(err?.message || "Failed to save AMP alert");
              loadAlertsRef.current({ skipAmpBackgroundSync: true });
            });
        }
        return;
      } catch (err) {
        message.error(err?.message || "Failed to save AMP alert");
        setLoading(false);
      }
      return;
    }

    if (isCorrelation && (!promExpr || !logExpr)) {
      return message.error("PromQL and LogQL queries are required");
    }
    if (!isCorrelation && !vals.expression && !expression) {
      return message.error("Query expression is required");
    }
    setLoading(true);
    const payload = {
      title: vals.title,
      description: vals.description?.trim() || undefined,
      datasource: vals.dataSource,
      prom_expr: promExpr,
      log_expr: logExpr,
      receiver: Array.isArray(vals.notificationChannels)
        ? vals.notificationChannels[0]
        : vals.notificationChannels,
      include_dashboard: vals.includeDashboard || false,
      dashboard_uid: selectDashboardTitle,
      panel_id: null,
      include_view_data: vals.viewData || false,
      enable_auto_rca: vals.enableAutoRca || false,
      extra_labels: vals.extraLabels || {},
      for_duration: secondsToForDuration(vals.relativeFrom),
      severity: vals.severity || "critical",
      no_data_state: vals.noDataState || "OK",
      exec_err_state: vals.execErrState || "OK",
      threshold_op: operatorToThresholdOp(vals.operator || ">"),
      threshold_value: resolvedThreshold,
      ...(isCorrelation && {
        prom_threshold: vals.promThreshold ?? resolvedThreshold,
        loki_threshold: vals.lokiThreshold ?? resolvedThreshold,
      }),
    };
    try {
      let savedResponse;
      if (editing) {
        savedResponse = await alertApi.updateAlert(editing.title, payload);
        message.success("Alert updated successfully");
      } else {
        savedResponse = await alertApi.createAlert(payload);
        if (savedResponse?.platform === "amp") {
          message.success(savedResponse?.message || "Metric alert created in AMP (Grafana at capacity)");
        } else {
          message.success("Alert created successfully");
        }
      }
      const responseData = savedResponse?.data || editing?.data || [];
      const firstRule = responseData[0] || {};
      const rel = firstRule.relativeTimeRange || {};
      const explorer = savedResponse?.explorer || {};
      const notificationChannels = Array.isArray(savedResponse?.notificationChannels)
        ? savedResponse.notificationChannels
        : [payload.receiver].filter(Boolean);
      const placedPlatform = savedResponse?.platform || editing?.platform || "grafana";
      const savedAlert = {
        ...(editing || {}),
        platform: placedPlatform,
        title: savedResponse?.title || editing?.title || vals.title,
        id: savedResponse?.alert_id || editing?.id || vals.title,
        data: responseData,
        notificationChannels,
        ruleGroup: savedResponse?.ruleGroup || editing?.ruleGroup,
        labels: (() => {
          const {
            auto_rca: _ignored,
            jira_enabled: _je,
            jira_connector_id: _jc,
            jira_project_key: _jp,
            jira_client_id: _jcl,
            ...restLabels
          } = editing?.labels || {};
          return {
            ...restLabels,
            ...(vals.extraLabels || {}),
            severity: vals.severity || editing?.severity || "warning",
            ...(vals.enableAutoRca ? { auto_rca: "true" } : {}),
          };
        })(),
        severity: vals.severity || editing?.severity || "warning",
        operator: vals.operator || editing?.operator || ">",
        threshold_value: resolvedThreshold,
        relativeFrom: vals.relativeFrom ?? rel.from ?? editing?.relativeFrom ?? 300,
        relativeTo: vals.relativeTo ?? rel.to ?? editing?.relativeTo ?? 0,
        viewData: vals.viewData
          ? (explorer["View Data"] ||
              explorer["View Data (Prometheus)"] ||
              explorer["View Data (Loki)"] ||
              explorer.ExploreMetricsURL ||
              explorer.ExploreLogsURL ||
              editing?.viewData)
          : undefined,
        viewDashboard: vals.includeDashboard ? (explorer.Dashboard || editing?.viewDashboard) : undefined,
      };

      mergeSavedAlertIntoList(savedAlert, editing);
      await loadAlertsRef.current();
      alertApi.getAlertCapabilities().then(setAlertCapabilities).catch(() => {});
      setModalVisible(false);
      form.resetFields();
      setExpression("");
      setEditing(null);
    } catch {
      message.error("Failed to save alert");
    } finally {
      setLoading(false);
    }
  }, [expression, editing, selectDashboardTitle, form, mergeSavedAlertIntoList, resolveAlertAccount, alertCapabilities]);

  const handleCancel = useCallback(() => {
    form.resetFields();
    setModalVisible(false);
    setExpression("");
    setEditing(null);
    setChecked(false);
    setTitleSuggestions([]);
    setTitleSuggestionsLoading(false);
    setSelectDashboardTitle("");
    setSeededPipelineLabels(null);
    setSeededPipelineTitle("");
  }, [form]);

  // Deep-link from Pipeline Discovery: /alerts?edit=1&alert=...
  useEffect(() => {
    const target = String(editAlertName || "").trim().toLowerCase();
    if (!target || editAlertConsumedRef.current || loading || alerts.length === 0) {
      return;
    }
    const match = alerts.find(
      (a) => String(a.title || "").trim().toLowerCase() === target,
    );
    if (!match) return;
    editAlertConsumedRef.current = true;
    onEdit(match);
    onEditAlertConsumed?.();
  }, [editAlertName, alerts, loading, onEditAlertConsumed]);

  useEffect(() => {
    return () => {
      if (titleSuggestionDebounceRef.current) {
        clearTimeout(titleSuggestionDebounceRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (!modalVisible) {
      setTitleSuggestions([]);
      setTitleSuggestionsLoading(false);
      setSeededPipelineLabels(null);
      setSeededPipelineTitle("");
    }
  }, [modalVisible]);

  const displayAlerts = useMemo(
    () => alerts.map((alert) => applySilenceOverlay(alert, silences)),
    [alerts, silences]
  );

  const columns = [
    {
      title: <span style={{ color: isDark ? "#e6edf3" : undefined }}>Title</span>,
      dataIndex: "title",
      key: "title",
      render: (t) => <strong style={{ color: isDark ? "#e6edf3" : undefined }}>{t}</strong>,
      sorter: (a, b) => a.title.localeCompare(b.title),
    },
    {
      title: <span style={{ color: isDark ? "#e6edf3" : undefined }}>Rule</span>,
      dataIndex: "data",
      key: "rule",
      render: (arr) => (
        <span style={{ color: isDark ? "#adbac7" : undefined }}>
          {arr.length
            ? `${arr[0].model.expr} (from ${arr[0].relativeTimeRange.from} to ${arr[0].relativeTimeRange.to})`
            : "—"}
        </span>
      ),
      ellipsis: true,
    },
    {
      title: <span style={{ color: isDark ? "#e6edf3" : undefined }}>Channels</span>,
      dataIndex: "notificationChannels",
      key: "channels",
      render: (ch) => <span style={{ color: isDark ? "#adbac7" : undefined }}>{ch.join(", ") || "—"}</span>,
      ellipsis: true,
    },
    {
      title: <span style={{ color: isDark ? "#e6edf3" : undefined }}>Actions</span>,
      key: "actions",
      render: (_, rec) => (
        <Space onClick={(e) => e.stopPropagation()} wrap>
          <AlertSilenceIconButton
            isSilenced={Boolean(rec.isSilenced || rec.silenceId)}
            onClick={() =>
              rec.isSilenced || rec.silenceId
                ? onUnsilence(rec)
                : onSilence([
                    {
                      labelName: "alertname",
                      operator: "=",
                      labelValue: rec.title,
                    },
                  ])
            }
            disabled={isViewer}
          />
          <Tooltip title="Edit Alert">
            <Button
              icon={<EditFilled />}
              type="text"
              size="small"
              onClick={() => onEdit(rec)}
              disabled={loading || isViewer}
            />
          </Tooltip>

          <Popconfirm
            title="Are you sure you want to delete this alert?"
            onConfirm={() => onDelete(rec)}
            okText="Yes"
            cancelText="No"
          >
            <Tooltip title="Delete">
              <Button
                icon={<DeleteFilled />}
                type="text"
                danger
                size="small"
                disabled={loading || isViewer}
              />
            </Tooltip>
          </Popconfirm>
          {rec.viewData && (
            <Tooltip title="View Data">
              <Button
                icon={<EyeOutlined />}
                type="text"
                size="small"
                onClick={(e) => {
                  e.preventDefault();
                  window.open(rec.viewData, "_blank");
                }}
              />
            </Tooltip>
          )}

          {rec.viewDashboard && (
            <Tooltip title="View Dashboard">
              <Button
                icon={<EyeOutlined />}
                type="text"
                size="small"
                onClick={(e) => {
                  e.preventDefault();
                  window.open(rec.viewDashboard, "_blank");
                }}
              />
            </Tooltip>
          )}
        </Space>
      ),
      width: 220,
      fixed: "right",
    },
  ];
  const handleDataSourceChange = useCallback((value) => {
    setDatasource(value);
  }, []);

  const handleAddFeild = () => {
    setSelectFields([...selectFields, ""]);
  };
  const handleRemoveFeild = (index) => {
    const updatedFields = [...selectFields];
    updatedFields.splice(index, 1);
    setSelectFields(updatedFields);
  };
  const handleSelectchange = (index, value) => {
    const update = [...selectFields];
    update[index] = value;
    setSelectFields(update);
  };

  return (
    <>
      <EnhancedAlertRulesView
        alerts={displayAlerts}
        loading={loading}
        ampSyncing={ampSyncing}
        alertCapabilities={alertCapabilities}
        initialSearchQuery={initialSearchQuery}
        initialPlatformFilter={initialPlatformFilter}
        initialExpandAlertName={initialSearchQuery}
        onRefresh={() => {
          loadAlerts();
          onRefreshSilences?.();
        }}
        onCreateAlert={() => {
          setEditing(null);
          setTitleSuggestions([]);
          setTitleSuggestionsLoading(false);
          setSelectDashboardTitle("");
          form.resetFields();
          form.setFieldsValue({
            relativeFrom: 300,
            relativeTo: 0,
            ruleGroup: "app-alerts",
          });
          ensureLogsLoaded();
          setDatasource("");
          setModalVisible(true);
        }}
        onEditAlert={onEdit}
        onDeleteAlert={onDelete}
        onSilenceAlert={(alert) => {
          onSilence(
            [{ labelName: "alertname", operator: "=", labelValue: alert.title }],
            alert.platform === AMP_PLATFORM ? AMP_PLATFORM : "grafana",
          );
        }}
        onUnsilenceAlert={(alert) => onUnsilence(alert)}
        onAskAIDebugger={handleAskAIDebugger}
        isViewer={isViewer}
      />

      <ClairAIAlertCreator
        visible={modalVisible}
        onCancel={handleCancel}
        onSubmit={onSubmit}
        form={form}
        editing={editing}
        loading={loading}
        dataSource={dataSource}
        notificationNames={notificationNames}
        titleSuggestions={titleSuggestions}
        titleSuggestionsLoading={titleSuggestionsLoading}
        onAlertTitleChange={onAlertTitleInput}
        logsService={logsService}
        labelOptions={labelOptions}
        clientId={resolveAlertAccount()?.clientId}
        awsAccountId={resolveAlertAccount()?.awsAccountId}
        expression={expression}
        setExpression={onExprChange}
        dashboardUid={dashboardUid}
        selectDashboardTitle={selectDashboardTitle}
        onDashboardSelect={handleDashboardSelect}
        alertCapabilities={alertCapabilities}
        initialExtraLabels={seededPipelineLabels}
        initialTitle={seededPipelineTitle}
        alertCapabilities={alertCapabilities}
        initialExtraLabels={seededPipelineLabels}
        initialTitle={seededPipelineTitle}
      />
    </>
  );
};

/* =========================================================================
   2) GROUPED ALERTS PAGE
======================================================================== */
const GroupedAlertsPage = ({ silences = [], onRefreshSilences }) => {
  const { isDark } = useTheme();
  const [loading, setLoading] = useState(false);
  const [rawGroupsData, setRawGroupsData] = useState([]);
  const [rawAlerts, setRawAlerts] = useState([]);
  const [alertsData, setAlertsData] = useState([]);
  const [filterState, setFilterState] = useState("all");
  const [searchText, setSearchText] = useState("");
  const [dataFetched, setDataFetched] = useState(false);
  const [availableLabels, setAvailableLabels] = useState([]);
  const [active, setActive] = useState(false);

  // Normalize API state to UI values (firing->active, etc.) for consistent display/filtering
  const normalizeAlertState = (raw) => {
    const s = (raw || "").toLowerCase();
    if (s === "firing") return "active";
    if (s === "suppressed" || s === "silenced" || s === "inhibited") return "suppressed";
    if (s === "unprocessed" || s === "pending") return s === "pending" ? "pending" : "unprocessed";
    return s || "unknown";
  };

  const hasSuppressionMarker = (alert) => {
    const status = alert?.status || {};
    const suppressionKeys = ["silencedBy", "inhibitedBy", "mutedBy"];

    return suppressionKeys.some((key) => {
      const value = status[key] ?? alert?.[key];
      if (Array.isArray(value)) return value.length > 0;
      return Boolean(value);
    });
  };

  const getAlertmanagerState = (alert, activeSilences = []) => {
    if (hasSuppressionMarker(alert)) {
      return "suppressed";
    }

    const labels = alert?.labels || {};
    const silenceMatch = findActiveSilenceForAlert(
      {
        title: labels.alertname || labels.rulename,
        labels,
        fingerprint: alert?.fingerprint,
        id: alert?.fingerprint,
      },
      activeSilences
    );
    if (silenceMatch) {
      return "suppressed";
    }

    return normalizeAlertState(alert?.status?.state);
  };

  const flattenAlertmanagerGroups = (rawGroups, activeSilences = []) => {
    const fl = [];
    rawGroups.forEach((group) => {
      const receiverName = group.receiver?.name || "";
      (group.alerts || []).forEach((alert) => {
        fl.push({
          state: getAlertmanagerState(alert, activeSilences),
          startsAt: alert.startsAt,
          endsAt: alert.endsAt,
          updatedAt: alert.updatedAt,
          labels: alert.labels || {},
          annotations: alert.annotations || {},
          receiver: receiverName,
          fingerprint: alert.fingerprint,
          key: alert.fingerprint, // add key for table
        });
      });
    });
    return fl;
  };

  const filterAlerts = (data) => {
    if (!data.length) return [];

    // Apply state filtering
    let filtered = data.filter(
      (r) => filterState === "all" || r.state.toLowerCase() === filterState
    );

    // Apply search text filtering with EXACT MATCH logic
    // Fixed: Previously used .includes() which caused partial matches
    // Issues fixed:
    // 1. REF_ID filter with value 'B' was also returning 'A' (because 'AB' contains 'B')
    // 2. Datasource UID filter was doing partial matches instead of exact
    // 3. Grafana_Folder 'alerts' was returning 'Observability Platform Alerts'
    // Now: Only exact matches on label values, keys, or key:value pairs
    if (searchText.trim()) {
      const searchLower = searchText.toLowerCase().trim();
      
      filtered = filtered.filter((r) => {
        // Check for exact match in label values (e.g., REF_ID="B" matches only "B", not "AB")
        const labelValues = Object.values(r.labels || {});
        const hasExactLabelValueMatch = labelValues.some(v => 
          String(v).toLowerCase() === searchLower
        );
        
        if (hasExactLabelValueMatch) {
          return true;
        }
        
        // Check for exact match in label keys
        const labelKeys = Object.keys(r.labels || {});
        const hasExactLabelKeyMatch = labelKeys.some(k => 
          String(k).toLowerCase() === searchLower
        );
        
        if (hasExactLabelKeyMatch) {
          return true;
        }
        
        // Check for exact match in annotation values
        const annotationValues = Object.values(r.annotations || {});
        const hasExactAnnotationMatch = annotationValues.some(v => 
          String(v).toLowerCase() === searchLower
        );
        
        if (hasExactAnnotationMatch) {
          return true;
        }
        
        // Check for key:value pair exact match (e.g., "ref_id:B" or "REF_ID:B")
        const labelsArray = Object.entries(r.labels || {});
        const hasKeyValueMatch = labelsArray.some(([k, v]) => {
          const keyValueStr = `${k}:${v}`.toLowerCase();
          const keyValueStrWithSpace = `${k}: ${v}`.toLowerCase();
          return keyValueStr === searchLower || keyValueStrWithSpace === searchLower;
        });
        
        if (hasKeyValueMatch) {
          return true;
        }
        
        // No exact match found
        return false;
      });
    }

    return filtered;
  };

  // Extract all available label keys from alerts for group by dropdown
  const extractAvailableLabels = (alerts) => {
    const labelSet = new Set();

    alerts.forEach((alert) => {
      if (alert.labels) {
        Object.keys(alert.labels).forEach((key) => labelSet.add(key));
      }
    });

    return [...labelSet].sort();
  };

  const handleRefresh = async () => {
    setLoading(true);
    try {
      await onRefreshSilences?.();
      const raw = await alertApi.getAlertmanagerGroups();
      setRawGroupsData(raw);
      setDataFetched(true);
    } catch {
      message.error("Failed to refresh alerts");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    onRefreshSilences?.();
    const interval = setInterval(() => {
      onRefreshSilences?.();
    }, 30000);
    return () => clearInterval(interval);
  }, [onRefreshSilences]);

  // Only fetch data once when component mounts
  useEffect(() => {
    if (!dataFetched) {
      handleRefresh();
    }
  }, [dataFetched]);

  // Re-apply silence overlay when groups or silences change
  useEffect(() => {
    if (!rawGroupsData.length) {
      setRawAlerts([]);
      setAvailableLabels([]);
      return;
    }

    const flat = flattenAlertmanagerGroups(rawGroupsData, silences);
    setAvailableLabels(extractAvailableLabels(flat));
    setRawAlerts(flat);
  }, [rawGroupsData, silences]);

  // Update when filters change
  useEffect(() => {
    setAlertsData(filterAlerts(rawAlerts));
  }, [rawAlerts, filterState, searchText]);

  const getStatusColor = (state) => {
    switch ((state || "").toLowerCase()) {
      case "active":
      case "firing":
        return "#199D3A";
      case "suppressed":
        return "gold";
      case "unprocessed":
        return "blue";
      case "pending":
        return "orange";
      case "normal":
      case "resolved":
        return "default";
      default:
        return "default";
    }
  };

  const getStatusIcon = (state) => {
    switch (state.toLowerCase()) {
      case "active":
        return ;
      case "suppressed":
        return ;
      case "unprocessed":
        return ;
      default:
        return null;
    }
  };

  // Generate options for the disabled group by dropdown
  const getGroupByOptions = () => {
    const commonOptions = ["alertname", "instance", "job", "severity"];

    // Add any additional labels found in the alerts
    availableLabels.forEach((label) => {
      if (!commonOptions.includes(label)) {
        commonOptions.push(label);
      }
    });

    return commonOptions.map((option) => ({
      label: option,
      value: option,
    }));
  };

  // Simplified columns without grouping
  const columns = [
    // {
    //   title: "State",
    //   dataIndex: "state",
    //   key: "state",
    //   width: 120,

    //   render: (state) => (
    //     <Tag color={getStatusColor(state)}>
    //       {state?.charAt(0).toUpperCase() + state?.slice(1).toLowerCase()}
    //     </Tag>
    //   ),
    // },
    {
  title: "State",
  dataIndex: "state",
  key: "state",
  width: 120,
  render: (state) => {
    const isActive = state?.toLowerCase() === 'active';
    
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {isActive && <span className="pulse-dot" />}
        <Tag color={getStatusColor(state)}>
          {state?.charAt(0).toUpperCase() + state?.slice(1).toLowerCase()}
        </Tag>
      </div>
    );
  },
},
    {
      title: "Alert Info",
      key: "alert_info",
      render: (_, record) => (
        <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
          <div>
            <Text type="secondary">Started:</Text>{" "}
            {moment(record.startsAt).format("YYYY-MM-DD HH:mm:ss")}
          </div>
          {record.endsAt && (
            <div>
              <Text type="secondary">Ends:</Text>{" "}
              {moment(record.endsAt).format("YYYY-MM-DD HH:mm:ss")}
            </div>
          )}
          {record.receiver && (
            <div>
              <Text type="secondary">Receiver:</Text> {record.receiver}
            </div>
          )}

          {/* Show summary or description if available */}
          {record.annotations?.summary && (
            <div style={{ marginTop: 4 }}>
              <Text strong>Summary:</Text> {record.annotations.summary}
            </div>
          )}
          {!record.annotations?.summary && record.annotations?.description && (
            <div style={{ marginTop: 4 }}>
              <Text strong>Description:</Text> {record.annotations.description}
            </div>
          )}
        </div>
      ),
      width: "40%",
    },
    {
      title: "Labels",
      key: "labels",
      render: (_, record) => (
        <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
          {Object.entries(record.labels || {}).map(([k, v]) => (
            <Tag
              key={k}
              style={{
                marginRight: 0,
                // display: 'inline-block',
                // marginBottom: 2,
                // maxWidth: '100%',
                // overflow: 'hidden',
                // textOverflow: 'ellipsis',
                // whiteSpace: 'nowrap'
              }}
              //  className="metric-pill"
            >
              <Text strong>{k}: </Text>
              <span style={{ color: isDark ? "#e6edf3" : "black" }}>{v}</span>
            </Tag>
          ))}
          {Object.keys(record.labels || {}).length === 0 && (
            <Text type="secondary">No labels</Text>
          )}
        </div>
      ),
    },
  ];

  // Get alert count by state for summary
  const getAlertCountByState = () => {
    const counts = {
      active: 0,
      suppressed: 0,
      pending: 0,
      unprocessed: 0,
      total: rawAlerts.length,
    };
    rawAlerts.forEach((alert) => {
      const state = alert.state.toLowerCase();
      if (counts.hasOwnProperty(state)) {
        counts[state]++;
      }
    });
    return counts;
  };

  const alertCounts = getAlertCountByState();

  return (
    <div
      className="alerts-container"
      style={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
<div style={{ flexShrink: 0 }}>
  {/* Header with title and refresh */}
  <div
    style={{
      marginBottom: 16,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    }}
  >
    <Title level={4} style={{ margin: 0 }}>
      Grouped Alerts
    </Title>
    <Tooltip title="Refresh">
      <Button
        icon={<ReloadOutlined />}
        onClick={handleRefresh}
        loading={loading}
        style={{ 
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      />
    </Tooltip>
  </div>

  {/* Stat Cards */}
  <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
    <Col xs={24} sm={12} md={6}>
      <Card
        className={`stat-card ${filterState === 'active' ? 'stat-card-active' : ''}`}
        onClick={() => setFilterState(filterState === 'active' ? 'all' : 'active')}
        style={{ 
          background: filterState === 'active' ? (isDark ? '#1c2a1c' : '#f6ffed') : (isDark ? '#161b22' : '#fff'),
          borderColor: '#52c41a',
          border: isDark ? '1px solid #30363d' : undefined
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <div style={{ 
            width: 48, 
            height: 48, 
            background: '#52c41a', 
            borderRadius: 8,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            
          </div>
          <div>
            <div style={{ fontSize: 24, fontWeight: 'bold', color: isDark ? '#e6edf3' : '#000' }}>
              {alertCounts.active}
            </div>
            <Text type="secondary">Active</Text>
          </div>
        </div>
      </Card>
    </Col>

    <Col xs={24} sm={12} md={6}>
      <Card
        className={`stat-card ${filterState === 'suppressed' ? 'stat-card-active' : ''}`}
        onClick={() => setFilterState(filterState === 'suppressed' ? 'all' : 'suppressed')}
        style={{ 
          background: filterState === 'suppressed' ? (isDark ? '#2a241c' : '#fffbe6') : (isDark ? '#161b22' : '#fff'),
          borderColor: '#faad14',
          border: isDark ? '1px solid #30363d' : undefined
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <div style={{ 
            width: 48, 
            height: 48, 
            background: '#faad14', 
            borderRadius: 8,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            
          </div>
          <div>
            <div style={{ fontSize: 24, fontWeight: 'bold', color: isDark ? '#e6edf3' : '#000' }}>
              {alertCounts.suppressed}
            </div>
            <Text type="secondary">Suppressed</Text>
          </div>
        </div>
      </Card>
    </Col>

    <Col xs={24} sm={12} md={6}>
      <Card
        className={`stat-card ${filterState === 'unprocessed' ? 'stat-card-active' : ''}`}
        onClick={() => setFilterState(filterState === 'unprocessed' ? 'all' : 'unprocessed')}
        style={{ 
          background: filterState === 'unprocessed' ? (isDark ? '#1c2833' : '#e6f7ff') : (isDark ? '#161b22' : '#fff'),
          borderColor: '#1890ff',
          border: isDark ? '1px solid #30363d' : undefined
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <div style={{ 
            width: 48, 
            height: 48, 
            background: '#1890ff', 
            borderRadius: 8,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            
          </div>
          <div>
            <div style={{ fontSize: 24, fontWeight: 'bold', color: isDark ? '#e6edf3' : '#000' }}>
              {alertCounts.unprocessed}
            </div>
            <Text type="secondary">Unprocessed</Text>
          </div>
        </div>
      </Card>
    </Col>

    <Col xs={24} sm={12} md={6}>
      <Card
        className={`stat-card ${filterState === 'all' ? 'stat-card-active' : ''}`}
        onClick={() => setFilterState('all')}
        style={{ 
          background: filterState === 'all' ? (isDark ? '#1c2128' : '#f0f0f0') : (isDark ? '#161b22' : '#fff'),
          borderColor: isDark ? '#30363d' : '#d9d9d9',
          border: isDark ? '1px solid #30363d' : undefined
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <div style={{ 
            width: 48, 
            height: 48, 
            background: '#595959', 
            borderRadius: 8,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
          </div>
          <div>
            <div style={{ fontSize: 24, fontWeight: 'bold', color: isDark ? '#e6edf3' : '#000' }}>
              {alertCounts.total}
            </div>
            <Text type="secondary">Total</Text>
          </div>
        </div>
      </Card>
    </Col>
  </Row>
</div>
      <Card
        className="filters-card"
        style={{ marginBottom: 16, flexShrink: 0, background: isDark ? "#161b22" : undefined, border: isDark ? "1px solid #30363d" : undefined }}
        bodyStyle={{ padding: "16px", background: isDark ? "#161b22" : undefined }}
      >
        <Row
          gutter={[24, 16]}
          align="middle"
          justify="space-between"
          style={{ flexWrap: "wrap" }}
        >
          <div>
            {/* <span strong style={{ display: "block", marginBottom: 8}}>
                State Filter:
              </span> */}
            <Text strong style={{ display: "block", marginBottom: 8 }}>
              State Filter:
            </Text>
            <Radio.Group
              value={filterState}
              onChange={(e) => setFilterState(e.target.value)}
              buttonStyle="solid"
              optionType="button"
              style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}
            >
              <Radio.Button
                onChange={(e) => setActive(e.target.value)}
                value="all"
                style={{
                  flexGrow: 1,
                  textAlign: "center",
                  backgroundColor:
                    filterState === "all" ? "#007AFF" : (isDark ? "#161b22" : "#FFFFFF"),
                  color: filterState === "all" ? "white" : (isDark ? "#e6edf3" : "black"),
                  borderColor: "#007AFF",
                  borderRadius: "8px",
                }}
              >
                <span
                  style={{
                    color: filterState === "all" ? "white" : undefined,
                  }}
                >
                  <img
                    src={
                      filterState === "all"
                        ? "/alerticons/allwhitealert.svg" // white version
                        : "/alerticons/All.svg" // normal blue version
                    }
                    style={{
                      color: filterState === "all" ? "white" : undefined,
                    }}
                  />
                  All
                </span>
              </Radio.Button>
              <Radio.Button
                onChange={(e) => setActive(e.target.value)}
                value="active"
                style={{
                  flexGrow: 1,
                  textAlign: "center",
                  backgroundColor:
                    filterState === "active" ? "#16a34a" : (isDark ? "#161b22" : "#FFFFFF"),
                  color: filterState === "active" ? "white" : (isDark ? "#e6edf3" : "black"),
                  border: "1px solid #16a34a",
                  borderRadius: "8px",
                }}
              >
                <Badge
                  color={filterState === "active" ? "green" : "white"}
                  text={
                    <span>
                      <img
                        src={
                          filterState === "active"
                            ? "/alerticons/activewhiteicon.svg" // white version
                            : "/alerticons/active.svg" // normal green version
                        }
                        alt="Active Icon"
                      />
                      Active
                    </span>
                  }
                />
              </Radio.Button>
              <Radio.Button
                onChange={(e) => setActive(e.target.value)}
                value="suppressed"
                style={{
                  flexGrow: 1,
                  textAlign: "center",
                  backgroundColor:
                    filterState === "suppressed" ? "#FF9500" : (isDark ? "#161b22" : "#FFFFFF"),
                  color: filterState === "suppressed" ? "white" : (isDark ? "#e6edf3" : "black"),
                  border: "1px solid  #FF9500",
                  borderRadius: "8px",
                }}
              >
                <Badge
                  color={filterState === "suppressed" ? "#FF9500" : "white"}
                  text={
                    <span>
                      <img
                        src={
                          filterState === "suppressed"
                            ? "/alerticons/Suppressedwhite.svg" // white version Suppressedwhite
                            : "/alerticons/Suppressed.svg" // normal green version
                        }
                        style={{
                          width: 18,
                          height: 18,
                        }}
                      />
                      Suppressed
                    </span>
                  }
                />
              </Radio.Button>
              <Radio.Button
                onChange={(e) => setActive(e.target.value)}
                value="unprocessed"
                style={{
                  flexGrow: 1,
                  textAlign: "center",
                  backgroundColor:
                    filterState === "unprocessed" ? "#32ADE6" : (isDark ? "#161b22" : "#FFFFFF"),
                  color: filterState === "unprocessed" ? "white" : (isDark ? "#e6edf3" : "black"),
                  border: "1px solid #32ADE6",
                  borderRadius: "8px",
                }}
              >
                <Badge
                  color={filterState === "suppressed" ? "#32ADE6" : "white"}
                  text={
                    <span>
                      <img
                        src={
                          filterState === "unprocessed"
                            ? "/alerticons/unprocessedwhite.svg" // white version Suppressedwhite
                            : "/alerticons/unprocessed.svg" // normal green version
                        }
                        style={{
                          width: 18,
                          height: 18,
                        }}
                      />
                      Unprocessed
                    </span>
                  }
                />
              </Radio.Button>
            </Radio.Group>
          </div>
          <Col xs={24} md={8}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "6px",
              }}
            >
              <span>Search Labels:</span>
              <Input
                bordered
                placeholder="Search by exact label value (e.g., 'B', 'alerts', 'ref_id:B')"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                allowClear
                style={{ width: "100%" }}
              />
            </div>
          </Col>
          <Col>
            <div>
              <Text
                strong
                style={{
                  display: "block",
                  marginBottom: 8,
                }}
              >
                Group by fields: (disabled)
              </Text>
              <Select
                mode="multiple"
                placeholder="Grouping is currently disabled"
                value={[]}
                style={{
                  width: "100%",
                  backgroundColor: "#f5f5f5",
                  cursor: "not-allowed",
                }}
                disabled={true}
                options={getGroupByOptions()}
                dropdownStyle={{ display: "none" }}
              />
              <div style={{ marginTop: 8, display: "flex", gap: "8px" }}>
                <Button size="small" disabled style={{ cursor: "not-allowed" }}>
                  By Alert Name
                </Button>
                <Button size="small" disabled style={{ cursor: "not-allowed" }}>
                  By Instance
                </Button>
                <Button size="small" disabled style={{ cursor: "not-allowed" }}>
                  No Grouping
                </Button>
              </div>
            </div>
          </Col>
        </Row>

        {/* Active filter chips */}
          {(filterState !== 'all' || searchText.trim()) && (
            <div className="filter-chips-container">
              <Text strong style={{ fontSize: 13 }}>Active Filters:</Text>
              
              {filterState !== 'all' && (
                <span className="filter-chip">
                  State: {filterState.charAt(0).toUpperCase() + filterState.slice(1)}
                  <Button
                    type="text"
                    className="filter-chip-close"
                    onClick={() => setFilterState('all')}
                  >
                    ×
                  </Button>
                </span>
              )}
              
              {searchText.trim() && (
                <span className="filter-chip">
                  Search: "{searchText}"
                  <Button
                    type="text"
                    className="filter-chip-close"
                    onClick={() => setSearchText('')}
                  >
                    ×
                  </Button>
                </span>
              )}
              
              <Button 
                type="link" 
                size="small"
                onClick={() => {
                  setFilterState('all');
                  setSearchText('');
                }}
                style={{ marginLeft: 'auto', color: '#ff4d4f' }}
              >
                Clear All
              </Button>
            </div>
          )}
        </Card>

      <div
        style={{
          flex: 1,
          minHeight: 0,
          overflowY: "auto",
          overflowX: "hidden",
        }}
      >
      {alertsData.length > 0 ? (
        <Table
          className="alerts-table"
          columns={columns}
          dataSource={alertsData}
          rowKey="fingerprint"
          loading={loading}
          pagination={false}
          size="middle"
          locale={{ emptyText: "No alerts found" }}
          bordered
          sticky
          scroll={{ y: 400 }}
        />
      ) : (
        // <Card>
        //   <div style={{ textAlign: "center", padding: "40px 0" }}>
        //     {loading ? (
        //       <Spin size="large" />
        //     ) : (
        //       <>
        //         {/*  */}
        //         <div>
        //           {/* <span style={{ margin: 0, color: '#F1EAEA' }}>No alerts found matching your criteria</span> */}
        //           {/* <Text>No alerts found matching your criteria</Text> */}
        //           <img src="/nodatafound.svg" />
        //         </div>
        //         {(filterState !== "all" || searchText) && (
        //           <div style={{ marginTop: 16 }}>
        //             <Button
        //               onClick={() => {
        //                 setFilterState("all");
        //                 setSearchText("");
        //               }}
        //             >
        //               Clear Filters
        //             </Button>
        //           </div>
        //         )}
        //       </>
        //     )}
        //   </div>
        // </Card>
        <Card style={{ background: isDark ? "#161b22" : undefined, border: isDark ? "1px solid #30363d" : undefined }}>
        <div className="empty-state-container">
          {loading ? (
            <Spin size="large" />
          ) : (
            <>
              <img 
                src="/nodatafound.svg" 
                alt="No data found"
                className="empty-state-icon"
              />
              
              <div className="empty-state-title">
                No alerts match your filters
              </div>
              
              {(filterState !== "all" || searchText) ? (
                <>
                  <div className="empty-state-description">
                    Try adjusting or clearing your filters to see more results
                  </div>
                  
                  <div className="empty-state-filters">
                    <div style={{ fontWeight: 600, marginBottom: 8, color: isDark ? "#e6edf3" : "black" }}>Active filters:</div>
                    {filterState !== 'all' && (
                      <div className="empty-state-filter-item">
                        
                        <span>State: <strong>{filterState}</strong></span>
                      </div>
                    )}
                    {searchText && (
                      <div className="empty-state-filter-item">
                        
                        <span>Search: <strong>"{searchText}"</strong></span>
                      </div>
                    )}
                  </div>
                  
                  <Button 
                    type="primary"onClick={() => {
                      setFilterState("all");
                      setSearchText("");
                    }}
                  >
                    Clear All Filters
                  </Button>
                </>
              ) : (
                <>
                  <div className="empty-state-description">
                    No alerts have been triggered yet
                  </div>
                  <Text type="secondary" style={{ fontSize: 13 }}>
                    Alerts will appear here when they are triggered by your alert rules
                  </Text>
                </>
              )}
            </>
          )}
        </div>
      </Card>
      )}
      </div>
    </div>
  );
};

/* =========================================================================
   3) SILENCES PAGE
======================================================================== */
const SilencePage = ({ defaultMatchers, defaultPlatform = "grafana", onRefreshSilences, onDefaultMatchersConsumed }) => {
  const { isDark } = useTheme();
  const [silences, setSilences] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [editingSilence, setEditingSilence] = useState(null);
  const [form] = Form.useForm();
  const [activeFilter, setActiveFilter] = useState("active");
  const isViewer = !IsEnabled("Alerts");
  // Fetch all silences
  const fetchSilences = async (optimisticSilence) => {
    setLoading(true);
    try {
      let data = await fetchAllSilences();
      if (
        optimisticSilence?.id &&
        !data.some((silence) => silence.id === optimisticSilence.id)
      ) {
        data = [...data, optimisticSilence];
      }
      setSilences(data);
    } catch {
      if (optimisticSilence?.id) {
        setSilences((prev) =>
          prev.some((silence) => silence.id === optimisticSilence.id)
            ? prev
            : [...prev, optimisticSilence]
        );
      }
      message.error("Failed to fetch silences");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSilences();
  }, []);

  // Only open modal when we have explicit defaultMatchers from "Silence" button click
  // NOT when just navigating to the Silence tab
  useEffect(() => {
    if (defaultMatchers && defaultMatchers.length > 0) {
      form.resetFields();
      form.setFieldsValue({
        startTime: dayjs(),
        endTime: dayjs().add(1, "hour"),
        comment: `Silence for ${defaultMatchers[0].labelValue}`,
        matchersFormList: defaultMatchers,
        silencePlatform: defaultPlatform || "grafana",
      });
      setEditingSilence(null);
      setModalVisible(true);

      onDefaultMatchersConsumed?.();
    }
  }, [defaultMatchers, defaultPlatform, form, onDefaultMatchersConsumed]);

  // Handlers
  const handleCreateNew = () => {
    setEditingSilence(null);
    form.resetFields();
    form.setFieldsValue({
      // Don't set default values for startTime and endTime
      // Keep them empty initially
      matchersFormList: [{}],
      silencePlatform: defaultPlatform || "grafana",
    });
    setModalVisible(true);
  };

  const handleEdit = (silence) => {
    setEditingSilence(silence);
    form.setFieldsValue({
      startTime: dayjs(silence.startsAt),
      endTime: dayjs(silence.endsAt),
      comment: silence.comment,
      silencePlatform: silence.platform || "grafana",
      matchersFormList: silence.matchers.map((m) => ({
        labelName: m.name,
        operator: m.isRegex
          ? m.isEqual
            ? "=~"
            : "!~"
          : m.isEqual
          ? "="
          : "!=",
        labelValue: m.value,
      })),
    });
    setModalVisible(true);
  };

  const handleRecreate = (silence) => {
    form.resetFields();
    form.setFieldsValue({
      startTime: dayjs(),
      endTime: dayjs().add(2, "hours"),
      comment: silence.comment || "Recreated",
      silencePlatform: silence.platform || "grafana",
      matchersFormList: silence.matchers.map((m) => ({
        labelName: m.name,
        operator: m.isRegex
          ? m.isEqual
            ? "=~"
            : "!~"
          : m.isEqual
          ? "="
          : "!=",
        labelValue: m.value,
      })),
    });
    setEditingSilence(null);
    setModalVisible(true);
  };

  const handleUnsilence = async (id, platform = "grafana") => {
    setLoading(true);
    try {
      if (platform === AMP_PLATFORM) {
        await alertApi.deleteAmpSilence(id);
      } else {
        await alertApi.deleteSilence(id);
      }
      message.success("Unsilenced successfully");
      await fetchSilences();
      await onRefreshSilences?.();
    } catch {
      message.error("Failed to unsilence");
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async (values) => {
    setLoading(true);
    try {
      const matchers = values.matchersFormList.map((f) => {
        const isRegex = f.operator === "=~" || f.operator === "!~";
        const isEqual = f.operator === "=" || f.operator === "=~";
        return { name: f.labelName, value: f.labelValue, isRegex, isEqual };
      });

      const payload = {
        startsAt: values.startTime.toISOString(),
        endsAt: values.endTime.toISOString(),
        comment: values.comment,
        createdBy: "FrontendUser",
        matchers,
      };

      const platform =
        values.silencePlatform ||
        editingSilence?.platform ||
        defaultPlatform ||
        "grafana";
      const isAmp = platform === AMP_PLATFORM;

      let optimisticSilence = null;
      if (editingSilence) {
        if (isAmp) {
          await alertApi.updateAmpSilence(editingSilence.id, payload);
        } else {
          await alertApi.updateSilence(editingSilence.id, payload);
        }
        message.success("Silence updated successfully");
      } else {
        const created = isAmp
          ? await alertApi.createAmpSilence(payload)
          : await alertApi.createSilence(payload);
        message.success(
          isAmp ? "AMP silence created successfully" : "Silence created successfully",
        );
        const silenceId = created?.silenceID || created?.silenceId || created?.id;
        if (silenceId) {
          optimisticSilence = {
            id: silenceId,
            platform: isAmp ? AMP_PLATFORM : "grafana",
            status: { state: "active" },
            startsAt: payload.startsAt,
            endsAt: payload.endsAt,
            comment: payload.comment,
            createdBy: payload.createdBy,
            matchers: payload.matchers,
          };
        }
      }

      await fetchSilences(optimisticSilence);
      await onRefreshSilences?.(optimisticSilence);
      form.resetFields();
      setModalVisible(false);
      setEditingSilence(null);
    } catch (err) {
      const detail = err?.message || "Failed to save silence";
      message.error(detail.replace(/^Failed to (create|update) AMP silence:\s*/i, "") || detail);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    setModalVisible(false);
    setEditingSilence(null);
  };

  // Split silences into Active / Pending / Expired
  const categorizeSilences = () => {
    const now = moment();
    const active = [],
      pending = [],
      expired = [];

    silences.forEach((s) => {
      const state = s.status?.state?.toLowerCase();

      if (state === "active") active.push(s);
      else if (state === "pending") pending.push(s);
      else if (state === "expired") expired.push(s);
      else {
        if (moment(s.startsAt).isAfter(now)) pending.push(s);
        else if (moment(s.endsAt).isBefore(now)) expired.push(s);
        else active.push(s);
      }
    });

    return { active, pending, expired };
  };

  const { active, pending, expired } = categorizeSilences();

  // Table columns
  const silenceColumns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      width: 160,
      render: (id) => (
        <Tooltip title={id}>
          <Text
            copyable={{ text: id }}
            style={{
              fontFamily: "monospace",
              maxWidth: 200,
              display: "inline-block",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {id}
          </Text>
        </Tooltip>
      ),
    },
    {
      title: "State",
      dataIndex: ["status", "state"],
      key: "state",
      render: (state) => {
        const colorMap = {
          active: { bg: "#28A745", text: "#ffffff" }, // medium-dark green with white text
          pending: { bg: "#FFF7E6", text: "#FA8C16" }, // orange pill
          expired: { bg: "#FF3B304D", text: "#FF3B30" },
        };

        const lowerState = state?.toLowerCase();
        const { bg, text } = colorMap[lowerState] || {
          bg: "#f0f0f0",
          text: "#8c8c8c",
        };
        const formattedState =
          state?.charAt(0).toUpperCase() + state?.slice(1).toLowerCase();

        return (
          <span
            style={{
              backgroundColor: bg,
              color: text,
              padding: "2px 8px",
              borderRadius: "6px",
              fontWeight: 500,
              fontSize: "12px",
              display: "inline-block",
              minWidth: "60px",
              textAlign: "center",
            }}
          >
            {formattedState || "N/A"}
          </span>
        );
      },
      width: 110,
    },
    {
      title: "Comment",
      dataIndex: "comment",
      key: "comment",
      ellipsis: true,
      width: 220,
    },
    {
      title: "Time Range",
      key: "timeRange",
      render: (_, record) => (
        <div style={{ fontSize: "12px", color: isDark ? "#adbac7" : "#666" }}>
          <div>
            <b style={{ color: isDark ? "#e6edf3" : undefined }}>Start:</b> {moment(record.startsAt).format("YYYY-MM-DD HH:mm")}
          </div>
          <div>
            <b style={{ color: isDark ? "#e6edf3" : undefined }}>End:</b> {moment(record.endsAt).format("YYYY-MM-DD HH:mm")}
          </div>
        </div>
      ),
      width: 200,
    },
    {
      title: "Matchers",
      dataIndex: "matchers",
      key: "matchers",
      render: (matchers) =>
        Array.isArray(matchers) ? (
          <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
            {matchers.map((m, i) => (
              <Tag key={i} color="blue">
                {m.name}{" "}
                {m.isRegex ? (m.isEqual ? "=~" : "!~") : m.isEqual ? "=" : "!="}{" "}
                {m.value}
              </Tag>
            ))}
          </div>
        ) : (
          "—"
        ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) =>
        moment(record.endsAt).isBefore(moment()) ? (
          <Button
            type="primary"
            onClick={() => handleRecreate(record)}
            size="small"
          >
            Recreate
          </Button>
        ) : (
          <Space size="small">
            <Tooltip title="Edit silence">
              <Button
                icon={<EditFilled />}
                type="text"
                size="small"
                onClick={() => handleEdit(record)}
                disabled={isViewer}
              />
            </Tooltip>
            <Popconfirm
              title="Are you sure you want to unsilence this alert?"
              onConfirm={() => handleUnsilence(record.id, record.platform || "grafana")}
              okText="Yes"
              cancelText="No"
            >
              <span>
                <AlertSilenceIconButton
                  isSilenced={isSilenceRecordActionable(record)}
                  disabled={isViewer}
                />
              </span>
            </Popconfirm>
          </Space>
        ),
      width: 140,
      fixed: "right",
    },
  ];

  // Get the currently displayed silences based on the active filter
  const getFilteredSilences = () => {
    switch (activeFilter) {
      case "active":
        return active;
      case "pending":
        return pending;
      case "expired":
        return expired;
      default:
        return active;
    }
  };

  return (
    <div className="silences-container">
      <div
        style={{
          marginBottom: 16,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "12px",
        }}
      >
        <div>
          {/* <h2 level={4} className="text-xl mb-4" style={{ color: '#F1EAEA'}}>
            Alert Silences
          </h2> */}
          <Title level={4} style={{ margin: 0 }}>
            Alert Silences
          </Title>
          <Text type="secondary">
            {active.length} active, {pending.length} pending, {expired.length}{" "}
            expired
          </Text>
        </div>
        <Space>
          <Tooltip title="Refresh">
            <Button
              icon={<ReloadOutlined />}
              onClick={fetchSilences}
              loading={loading}
              style={{ 
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            />
          </Tooltip>
          <Button
            className="create-btn"
            type="primary"
            icon={<PlusOutlined />}
            size="large"
            onClick={handleCreateNew}
            disabled={isViewer}
          >
            Create Silence
          </Button>
        </Space>
      </div>

      {/* Status filter using Radio.Group styled like the other pages */}
      <Card
        className="filters-card"
        style={{ marginBottom: 16, background: isDark ? "#161b22" : undefined, border: isDark ? "1px solid #30363d" : undefined }}
        bodyStyle={{ padding: "16px", background: isDark ? "#161b22" : undefined }}
      >
        <Row gutter={[24, 16]}>
          <div>
            <Radio.Group
              value={activeFilter}
              onChange={(e) => setActiveFilter(e.target.value)}
              buttonStyle="solid"
              optionType="button"
              style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}
            >
              <Radio.Button
                value="active"
                onChange={(e) => setActiveFilter(e.target.value)}
                style={{
                  flexGrow: 1,
                  textAlign: "center",
                  backgroundColor:
                    activeFilter === "active" ? "#199D3A" : (isDark ? "#161b22" : "white"),
                  color: activeFilter === "active" ? "white" : (isDark ? "#e6edf3" : "black"),
                  border: "1px solid #199D3A",
                  borderRadius: "8px",
                }}
              >
                <Badge
                  color={activeFilter === "active" ? "#199D3A" : "white"}
                  text={
                    <span>
                      <img
                        src={
                          activeFilter === "active"
                            ? "/alerticons/activewhiteicon.svg"
                            : "/alerticons/activesilence.svg"
                        }
                      />
                      {`Active (${active.length})`}
                    </span>
                  }
                />
              </Radio.Button>
              <Radio.Button
                value="pending"
                onChange={(e) => setActiveFilter(e.target.value)}
                style={{
                  flexGrow: 1,
                  textAlign: "center",
                  backgroundColor:
                    activeFilter === "pending" ? "#FF9500" : (isDark ? "#161b22" : "white"),
                  color: activeFilter === "pending" ? "white" : (isDark ? "#e6edf3" : "black"),
                  border: "1px solid #FF9500",
                  borderRadius: "8px",
                }}
              >
                <Badge
                  color={activeFilter === "active" ? "#FF9500" : "white"}
                  text={
                    <span>
                      <img
                        src={
                          activeFilter === "pending"
                            ? "/alerticons/pendingwhite.svg"
                            : "/alerticons/pending.svg"
                        }
                      />
                      {`Pending (${pending.length})`}
                    </span>
                  }
                />
              </Radio.Button>
              <Radio.Button
                value="expired"
                onChange={(e) => setActiveFilter(e.target.value)}
                style={{
                  flexGrow: 1,
                  textAlign: "center",
                  backgroundColor:
                    activeFilter === "expired" ? "#FF3B30" : (isDark ? "#161b22" : "white"),
                  color: activeFilter === "expired" ? "white" : (isDark ? "#e6edf3" : "black"),
                  border: "1px solid #FF3B30",
                  borderRadius: "8px",
                }}
              >
                <Badge
                  color={activeFilter === "active" ? "#FF3B30" : "white"}
                  text={
                    <span>
                      <img
                        src={
                          activeFilter === "expired"
                            ? "/alerticons/expiredwhite.svg"
                            : "/alerticons/expired.svg"
                        }
                      />
                      {`Expired (${expired.length})`}
                    </span>
                  }
                />
              </Radio.Button>
            </Radio.Group>
          </div>
        </Row>
      </Card>

      <Table
        // className="custom-ant-table rounded-rows-table"
        dataSource={getFilteredSilences()}
        columns={silenceColumns}
        rowKey="id"
        loading={loading}
        pagination={false}
        locale={{
          emptyText: `No ${activeFilter} silences found`,
        }}
        bordered
      />

      <Modal
        title={editingSilence ? "Edit Silence" : "Create Silence"}
        open={modalVisible}
        onCancel={handleCancel}
        footer={null}
        width={700}
        destroyOnClose
      >
        <Form form={form} layout="vertical" onFinish={handleSave}>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="startTime"
                label="Start Time"
                rules={[
                  { required: true, message: "Start time is required" },
                  // Removed the validation that prevents past dates
                  // Allow both past and future dates for better flexibility
                ]}
              >
                <DatePicker
                  showTime={{
                    use12Hours: true,
                    format: "hh:mm a",
                  }}
                  format="DD/MM/YYYY hh:mm a"
                  style={{ width: "100%" }}
                  changeOnBlur={true}
                  inputReadOnly={true}
                  placeholder="Select date and time"
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="endTime"
                label="End Time"
                rules={[
                  { required: true, message: "End time is required" },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      const startTime = getFieldValue("startTime");
                      if (!value || !startTime || value.isAfter(startTime)) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error("End time must be after start time")
                      );
                    },
                  }),
                  () => ({
                    validator(_, value) {
                      if (!value || value.isAfter(dayjs())) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error("End time must be in the future")
                      );
                    },
                  }),
                ]}
              >
                <DatePicker
                  showTime={{
                    use12Hours: true,
                    format: "hh:mm a",
                  }}
                  format="DD/MM/YYYY hh:mm a"
                  style={{ width: "100%" }}
                  changeOnBlur={true}
                  inputReadOnly={true}
                  placeholder="Select date and time"
                />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item
            name="silencePlatform"
            label="Alert platform"
            initialValue={defaultPlatform || "grafana"}
          >
            <Select disabled={Boolean(editingSilence)}>
              <Option value="grafana">Grafana</Option>
              <Option value={AMP_PLATFORM}>AMP (Prometheus)</Option>
            </Select>
          </Form.Item>

          <Form.Item
            name="comment"
            label="Comment"
            rules={[{ required: true, message: "Comment is required" }]}
          >
            <Input.TextArea
              rows={2}
              placeholder="Enter a descriptive comment"
            />
          </Form.Item>

          <Form.List
            name="matchersFormList"
            initialValue={[{}]}
            rules={[
              {
                validator: async (_, value) => {
                  if (!value || value.length === 0) {
                    return Promise.reject(
                      new Error("At least one matcher is required")
                    );
                  }
                },
              },
            ]}
          >
            {(fields, { add, remove }) => (
              <>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 8,
                  }}
                >
                  <Title level={5} style={{ margin: 0 }}>
                    Matchers
                  </Title>
                  <Button
                    type="dashed"
                    onClick={() => add()}disabled={isViewer}
                  >
                    Add Matcher
                  </Button>
                </div>

                {fields.map(({ key, name, ...rest }) => (
                  <Card
                    key={key}
                    size="small"
                    style={{ marginBottom: 8 }}
                    extra={
                      fields.length > 1 ? (
                        <Button
                          danger
                          onClick={() => remove(name)}
                          type="link"
                          size="small"
                        />
                      ) : null
                    }
                  >
                    <Row gutter={8} align="middle">
                      <Col xs={24} sm={8}>
                        <Form.Item
                          {...rest}
                          name={[name, "labelName"]}
                          rules={[
                            { required: true, message: "Label name required" },
                          ]}
                          style={{ marginBottom: 0 }}
                        >
                          <Input placeholder="alertname" />
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={4}>
                        <Form.Item
                          {...rest}
                          name={[name, "operator"]}
                          rules={[
                            { required: true, message: "Operator required" },
                          ]}
                          style={{ marginBottom: 0 }}
                        >
                          <Select placeholder="=">
                            <Option value="=">=</Option>
                            <Option value="!=">!=</Option>
                            <Option value="=~">=~</Option>
                            <Option value="!~">!~</Option>
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col xs={24} sm={12}>
                        <Form.Item
                          {...rest}
                          name={[name, "labelValue"]}
                          rules={[
                            { required: true, message: "Value required" },
                          ]}
                          style={{ marginBottom: 0 }}
                        >
                          <Input placeholder="Value" />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Card>
                ))}
              </>
            )}
          </Form.List>

          <Form.Item style={{ marginTop: 16, marginBottom: 0 }}>
            <Space>
              <Button onClick={handleCancel}>Cancel</Button>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                disabled={isViewer}
              >
                {editingSilence ? "Update Silence" : "Create Silence"}
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

/* =========================================================================
   3b) CONTACT POINTS PAGE (Grafana-like)
======================================================================== */
const CHANNEL_OPTIONS = [
  { value: "email", label: "Email" },
  { value: "teams", label: "Microsoft Teams" },
  { value: "email_teams", label: "Email + Teams" },
  { value: "sns", label: "AWS SNS" },
  { value: "slack", label: "Slack" },
  { value: "pagerduty", label: "PagerDuty" },
  { value: "opsgenie", label: "OpsGenie" },
  { value: "victorops", label: "VictorOps" },
];

const ContactPointsPage = () => {
  const { isDark } = useTheme();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [configModalVisible, setConfigModalVisible] = useState(false);
  const [editingRecord, setEditingRecord] = useState(null);
  const [configData, setConfigData] = useState(null);
  const [form] = Form.useForm();
  const isViewer = !IsEnabled("Alerts");

  const fetchContactPoints = async () => {
    setLoading(true);
    try {
      const data = await alertApi.getContactPoints();
      setList(Array.isArray(data) ? data : []);
    } catch {
      message.error("Failed to fetch contact points");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchContactPoints();
  }, []);

  const handleCreate = () => {
    setEditingRecord(null);
    form.resetFields();
    form.setFieldsValue({ channel: "email", disableResolveMessage: false });
    setModalVisible(true);
  };

  const handleEdit = async (record) => {
    setEditingRecord(record);
    form.resetFields();
    const channel = record.grafana_managed_receiver_configs?.[0]?.type || "email";
    const initial = {
      name: record.name,
      channel,
      disableResolveMessage: false,
    };
    try {
      const config = await alertApi.getContactPointConfig(record.name);
      if (config.channel) initial.channel = config.channel;
      if (config.addresses) initial.email_addresses = Array.isArray(config.addresses) ? config.addresses.join(", ") : config.addresses;
      if (config.email_subject) initial.email_subject = config.email_subject;
      if (config.singleEmail) initial.singleEmail = config.singleEmail;
      if (config.teams_url) initial.teams_url = config.teams_url;
      if (config.teams_title) initial.teams_title = config.teams_title;
      if (config.teams_message) initial.teams_message = config.teams_message;
    } catch {
      // Config may not exist for native AMG channels
    }
    form.setFieldsValue(initial);
    setModalVisible(true);
  };

  const handleViewConfig = async (name) => {
    try {
      const data = await alertApi.getContactPointConfig(name);
      setConfigData(data);
      setConfigModalVisible(true);
    } catch {
      message.error("Failed to load config");
    }
  };

  const handleSave = async (values) => {
    setLoading(true);
    try {
      const payload = {
        channel: values.channel,
        disableResolveMessage: !!values.disableResolveMessage,
      };
      if (!editingRecord) payload.name = values.name?.trim();
      if (["email", "email_teams"].includes(values.channel) && values.email_addresses) {
        payload.email = {
          addresses: values.email_addresses,
          subject: values.email_subject || undefined,
          singleEmail: !!values.singleEmail,
        };
      }
      if (["teams", "email_teams"].includes(values.channel) && values.teams_url) {
        payload.teams = {
          url: values.teams_url,
          title: values.teams_title || undefined,
          message: values.teams_message || undefined,
        };
      }
      if (values.channel === "sns" && values.topic_arn) {
        payload.sns = {
          topic_arn: values.topic_arn,
          region: values.sns_region || "us-east-1",
          subject: values.sns_subject,
          body: values.sns_body,
        };
      }
      if (values.channel === "slack" && values.slack_url) {
        payload.slack = {
          url: values.slack_url,
          recipient: values.slack_recipient,
          title: values.slack_title,
          text: values.slack_text,
        };
      }
      if (values.channel === "pagerduty" && values.pd_integration_key) {
        payload.pagerduty = {
          integration_key: values.pd_integration_key,
          severity: values.pd_severity || "critical",
        };
      }
      if (values.channel === "opsgenie" && values.opsgenie_api_key) {
        payload.opsgenie = {
          api_key: values.opsgenie_api_key,
          message: values.opsgenie_message,
        };
      }
      if (values.channel === "victorops" && values.victorops_url) {
        payload.victorops = {
          url: values.victorops_url,
          message_type: values.victorops_message_type || "CRITICAL",
        };
      }

      if (editingRecord) {
        await alertApi.updateContactPoint(editingRecord.name, payload);
        message.success("Contact point updated");
      } else {
        await alertApi.createContactPoint({ ...payload, name: values.name?.trim() });
        message.success("Contact point created");
      }
      setModalVisible(false);
      setEditingRecord(null);
      await fetchContactPoints();
    } catch (e) {
      message.error(e?.message || "Failed to save contact point");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (name) => {
    setLoading(true);
    try {
      await alertApi.deleteContactPoint(name);
      message.success("Contact point deleted");
      await fetchContactPoints();
    } catch (e) {
      message.error(e?.message || "Failed to delete");
    } finally {
      setLoading(false);
    }
  };

  const typesFromRecord = (record) => {
    const configs = record.grafana_managed_receiver_configs || [];
    if (!configs.length) return "—";
    return configs.map((c) => c.type || "—").join(", ");
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (name) => (
        <Text strong style={{ fontFamily: "monospace" }}>{name || "—"}</Text>
      ),
    },
    {
      title: "Type",
      key: "type",
      render: (_, record) => typesFromRecord(record),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Space size="small">
          <Tooltip title="View routing config">
            <Button
              type="text"
              size="small"
              icon={<SettingOutlined />}
              onClick={() => handleViewConfig(record.name)}
            />
          </Tooltip>
          <Tooltip title="Edit">
            <Button
              type="text"
              size="small"
              icon={<EditFilled />}
              onClick={() => handleEdit(record)}
              disabled={isViewer}
            />
          </Tooltip>
          <Popconfirm
            title="Delete this contact point?"
            onConfirm={() => handleDelete(record.name)}
            okText="Yes"
            cancelText="No"
          >
            <Tooltip title="Delete">
              <Button type="text" size="small" icon={<DeleteFilled />} disabled={isViewer} />
            </Tooltip>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <div style={{ height: "100%", display: "flex", flexDirection: "column", overflow: "hidden" }}>
      <div
        style={{
          marginBottom: 16,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "12px",
        }}
      >
        <Title level={4} style={{ margin: 0 }}>Contact Points</Title>
        <Text type="secondary">{list.length} contact point(s)</Text>
        <Space>
          <Tooltip title="Refresh">
            <Button icon={<ReloadOutlined />} onClick={fetchContactPoints} loading={loading} />
          </Tooltip>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={handleCreate}
            disabled={isViewer}
          >
            New contact point
          </Button>
        </Space>
      </div>
      <Table
        dataSource={list}
        columns={columns}
        rowKey="name"
        loading={loading}
        pagination={{ pageSize: 10 }}
        locale={{ emptyText: "No contact points" }}
        bordered
      />

      <Modal
        title={editingRecord ? "Edit contact point" : "New contact point"}
        open={modalVisible}
        onCancel={() => { setModalVisible(false); setEditingRecord(null); form.resetFields(); }}
        footer={null}
        width={560}
        destroyOnClose
      >
        <Form form={form} layout="vertical" onFinish={handleSave}>
          <Form.Item name="name" label="Name" rules={[{ required: true, message: "Name is required" }]}>
            <Input placeholder="e.g. my-team-alerts" disabled={!!editingRecord} />
          </Form.Item>
          <Form.Item name="channel" label="Channel" rules={[{ required: true }]}>
            <Select options={CHANNEL_OPTIONS} placeholder="Select channel" />
          </Form.Item>
          <Form.Item noStyle shouldUpdate={(prev, curr) => prev.channel !== curr.channel}>
            {({ getFieldValue }) => {
              const ch = getFieldValue("channel");
              return (
                <>
                  {["email", "email_teams"].includes(ch) && (
                    <>
                      <Form.Item name="email_addresses" label="Email addresses" rules={[{ required: true }]}>
                        <Input placeholder="a@example.com, b@example.com" />
                      </Form.Item>
                      <Form.Item name="email_subject" label="Subject (optional)">
                        <Input />
                      </Form.Item>
                      <Form.Item name="singleEmail" valuePropName="checked">
                        <Checkbox>Single email to all addresses</Checkbox>
                      </Form.Item>
                    </>
                  )}
                  {["teams", "email_teams"].includes(ch) && (
                    <>
                      <Form.Item name="teams_url" label="Teams webhook URL" rules={[{ required: true }]}>
                        <Input placeholder="https://..." />
                      </Form.Item>
                      <Form.Item name="teams_title" label="Title (optional)">
                        <Input />
                      </Form.Item>
                      <Form.Item name="teams_message" label="Message (optional)">
                        <Input.TextArea rows={2} />
                      </Form.Item>
                    </>
                  )}
                  {ch === "sns" && (
                    <>
                      <Form.Item name="topic_arn" label="SNS Topic ARN" rules={[{ required: true }]}>
                        <Input placeholder="arn:aws:sns:region:account:topic" />
                      </Form.Item>
                      <Form.Item name="sns_region" label="Region" initialValue="us-east-1">
                        <Input />
                      </Form.Item>
                      <Form.Item name="sns_subject" label="Subject (optional)">
                        <Input />
                      </Form.Item>
                      <Form.Item name="sns_body" label="Body (optional)">
                        <Input.TextArea rows={2} />
                      </Form.Item>
                    </>
                  )}
                  {ch === "slack" && (
                    <>
                      <Form.Item name="slack_url" label="Slack webhook URL" rules={[{ required: true }]}>
                        <Input placeholder="https://..." />
                      </Form.Item>
                      <Form.Item name="slack_recipient" label="Channel (optional)">
                        <Input placeholder="#alerts" />
                      </Form.Item>
                      <Form.Item name="slack_title" label="Title (optional)">
                        <Input />
                      </Form.Item>
                      <Form.Item name="slack_text" label="Text (optional)">
                        <Input.TextArea rows={2} />
                      </Form.Item>
                    </>
                  )}
                  {ch === "pagerduty" && (
                    <>
                      <Form.Item name="pd_integration_key" label="Integration key" rules={[{ required: true }]}>
                        <Input />
                      </Form.Item>
                      <Form.Item name="pd_severity" label="Severity">
                        <Select options={[{ value: "critical" }, { value: "error" }, { value: "warning" }, { value: "info" }].map((o) => ({ ...o, label: o.value }))} />
                      </Form.Item>
                    </>
                  )}
                  {ch === "opsgenie" && (
                    <>
                      <Form.Item name="opsgenie_api_key" label="API key" rules={[{ required: true }]}>
                        <Input.Password />
                      </Form.Item>
                      <Form.Item name="opsgenie_message" label="Message (optional)">
                        <Input />
                      </Form.Item>
                    </>
                  )}
                  {ch === "victorops" && (
                    <>
                      <Form.Item name="victorops_url" label="Webhook URL" rules={[{ required: true }]}>
                        <Input placeholder="https://..." />
                      </Form.Item>
                      <Form.Item name="victorops_message_type" label="Message type">
                        <Select options={[{ value: "CRITICAL" }, { value: "WARNING" }, { value: "INFO" }].map((o) => ({ ...o, label: o.value }))} />
                      </Form.Item>
                    </>
                  )}
                </>
              );
            }}
          </Form.Item>
          <Form.Item name="disableResolveMessage" valuePropName="checked">
            <Checkbox>Disable resolve message</Checkbox>
          </Form.Item>
          <Form.Item style={{ marginBottom: 0, marginTop: 16 }}>
            <Space>
              <Button onClick={() => { setModalVisible(false); setEditingRecord(null); }}>Cancel</Button>
              <Button type="primary" htmlType="submit" loading={loading}>Save</Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title="Contact point config"
        open={configModalVisible}
        onCancel={() => { setConfigModalVisible(false); setConfigData(null); }}
        footer={null}
        width={480}
      >
        {configData && (
          <pre style={{ background: isDark ? "#161b22" : "#f5f5f5", padding: 12, borderRadius: 8, overflow: "auto", maxHeight: 400 }}>
            {JSON.stringify(configData, null, 2)}
          </pre>
        )}
      </Modal>
    </div>
  );
};

/* =========================================================================
   4) MAIN PAGE
======================================================================== */
const AlertsPage = () => {
  const { isDark } = useTheme();
  const [searchParams] = useSearchParams();
  const [view, setView] = useState("rules");
  const [rulesDeepLink, setRulesDeepLink] = useState({ alert: "", platform: "all" });
  const [pipelineCreateContext, setPipelineCreateContext] = useState(null);
  const [editAlertName, setEditAlertName] = useState("");
  const [defaultMatchers, setDefaultMatchers] = useState(null);
  const [defaultSilencePlatform, setDefaultSilencePlatform] = useState("grafana");
  const [silences, setSilences] = useState([]);
  const [active, setActive] = useState(false);
  const [filterState, setFilterState] = useState("all");

  const loadSilences = useCallback(async (optimisticSilence) => {
    try {
      let data = await fetchAllSilences();
      if (
        optimisticSilence?.id &&
        !data.some((silence) => silence.id === optimisticSilence.id)
      ) {
        data = [...data, optimisticSilence];
      }
      setSilences(data);
    } catch (e) {
      if (optimisticSilence?.id) {
        setSilences((prev) =>
          prev.some((silence) => silence.id === optimisticSilence.id)
            ? prev
            : [...prev, optimisticSilence]
        );
      }
      console.error(e);
    }
  }, []);

  useEffect(() => {
    loadSilences();
  }, [loadSilences]);

  useEffect(() => {
    const silenceFlag = searchParams.get("silence");
    const viewFlag = searchParams.get("view");
    const createFlag = searchParams.get("create");
    const editFlag = searchParams.get("edit");
    const alertName = (searchParams.get("alert") || "").trim();
    const platformParam = (searchParams.get("platform") || "").trim().toLowerCase();
    const pipelineId = (searchParams.get("pipelineId") || "").trim();
    const pipelineName = (searchParams.get("pipelineName") || "").trim();
    const pipelineType = (searchParams.get("pipelineType") || "").trim();

    if (createFlag === "1" || createFlag === "true") {
      setView("rules");
      if (pipelineId) {
        setPipelineCreateContext({
          pipelineId,
          pipelineName,
          pipelineType,
        });
      }
      return;
    }

    if (editFlag === "1" || editFlag === "true") {
      const platform =
        platformParam === AMP_PLATFORM
          ? AMP_PLATFORM
          : platformParam === "grafana"
            ? "grafana"
            : "all";
      setRulesDeepLink({ alert: alertName, platform });
      setEditAlertName(alertName);
      setView("rules");
      return;
    }

    // AMP / Teams "Create Silence" → Silences tab on /alerts
    if (silenceFlag === "1" || silenceFlag === "true") {
      const platform = platformParam === AMP_PLATFORM ? AMP_PLATFORM : "grafana";
      if (alertName) {
        setDefaultMatchers([
          { labelName: "alertname", operator: "=", labelValue: alertName },
        ]);
        setDefaultSilencePlatform(platform);
      } else if (platformParam === AMP_PLATFORM) {
        setDefaultSilencePlatform(AMP_PLATFORM);
      }
      setView("silences");
      return;
    }

    // AMP / Teams "View Alert" → Alert Rules tab on /alerts
    if (viewFlag === "rules" || platformParam === AMP_PLATFORM) {
      const platform =
        platformParam === AMP_PLATFORM
          ? AMP_PLATFORM
          : platformParam === "grafana"
            ? "grafana"
            : "all";
      setRulesDeepLink({ alert: alertName, platform });
      setView("rules");
    }
  }, [searchParams]);

  const handleUnsilence = async (target) => {
    const ruleTitle = typeof target === "string" ? target : target?.title;
    const silenceId = typeof target === "string" ? null : target?.silenceId;
    const s = silenceId
      ? silences.find((silence) => silence.id === silenceId)
      : silences.find((silence) => {
          if (!isSilenceCurrentlyActive(silence)) return false;
          return (silence.matchers || []).some((matcher) => {
            const labelName = (matcher.name || matcher.labelName || "").toLowerCase();
            if (!ALERT_NAME_LABELS.has(labelName)) return false;
            const matcherValue = String(matcher.value ?? "");
            const titleValue = String(ruleTitle ?? "");
            return (
              matcherValue === titleValue ||
              matcherValue.toLowerCase() === titleValue.toLowerCase()
            );
          });
        });

    if (!s?.id) {
      return message.error("No active silence found");
    }
    try {
      if (s.platform === AMP_PLATFORM) {
        await alertApi.deleteAmpSilence(s.id);
      } else {
        await alertApi.deleteSilence(s.id);
      }
      message.success("Unsilenced");
      await loadSilences();
    } catch {
      message.error("Failed to unsilence");
    }
  };

  // Refresh silences when returning to rules, grouped alerts, or opening the silences tab
  useEffect(() => {
    if (view === "silences" || view === "rules" || view === "grouped") {
      loadSilences();
    }
    // Contact points are refreshed on mount inside ContactPointsPage
  }, [view, loadSilences]);

  const renderContent = () => {
    switch (view) {
      case "grouped":
        return (
          <GroupedAlertsPage
            silences={silences}
            onRefreshSilences={loadSilences}
          />
        );
      case "silences":
        return (
          <SilencePage
            defaultMatchers={defaultMatchers}
            defaultPlatform={defaultSilencePlatform}
            onRefreshSilences={loadSilences}
            onDefaultMatchersConsumed={() => setDefaultMatchers(null)}
          />
        );
      case "contact-points":
        return <ContactPointsPage />;
      case "rules":
      default:
        return (
          <AlertRulesPage
            silences={silences}
            onRefreshSilences={loadSilences}
            initialSearchQuery={rulesDeepLink.alert}
            initialPlatformFilter={rulesDeepLink.platform}
            pipelineCreateContext={pipelineCreateContext}
            onPipelineCreateConsumed={() => setPipelineCreateContext(null)}
            editAlertName={editAlertName}
            onEditAlertConsumed={() => setEditAlertName("")}
            onSilence={(matchers, platform = "grafana") => {
              setDefaultMatchers(matchers);
              setDefaultSilencePlatform(platform);
              setView("silences");
            }}
            onUnsilence={handleUnsilence}
          />
        );
    }
  };

  return (
    <div style={{ height: "100%", display: "flex", flexDirection: "column", overflow: "hidden" }}>
      <Radio.Group
        value={view}
        onChange={(e) => setView(e.target.value)}
        optionType="button"
        style={{
          flexShrink: 0,
          marginBottom: 16,
          display: "flex",
          gap: "10px",
          flexWrap: "wrap",
        }}
        buttonStyle="solid"
        size="middle"
      >
        <Radio.Button
          value="rules"
          onChange={(e) => setActive(e.target.value)}
          className="custom-radio-btn morph-btn"
          style={{
            color: isDark ? (view === "rules" ? "#fff" : "#adbac7") : undefined,
          }}
        >
          <Space onClick={() => setActive(true)}>
            <img
              src={
                view === "rules"
                  ? "/alerticons/alertwhite.svg" // white version
                  : "/alerticons/alertrules.svg" // normal blue version
              }
              alt="Alert Icon"
            />
            <span style={{ color: isDark ? (view === "rules" ? "#fff" : "#adbac7") : undefined }}>
              Alert Rules
            </span>
          </Space>
        </Radio.Button>

        <Radio.Button
          value="grouped"
          onChange={(e) => setActive(e.target.value)}
          className="morph-btn"
          style={{
            color: isDark ? (view === "grouped" ? "#fff" : "#adbac7") : undefined,
          }}
        >
          <Space onClick={() => setActive(true)}>
            <img
              src={
                view === "grouped"
                  ? "/alerticons/groupedwhite.svg" // white version
                  : "/alerticons/groupedicon.svg" // normal blue version
              }
              alt="Grouped Alerts Icon"
            />
            <span style={{ color: isDark ? (view === "grouped" ? "#fff" : "#adbac7") : undefined }}>
              Grouped Alerts
            </span>
          </Space>
        </Radio.Button>
        <Radio.Button
          value="silences"
          onChange={(e) => setActive(e.target.value)}
          className="morph-btn"
          style={{
            color: isDark ? (view === "silences" ? "#fff" : "#adbac7") : undefined,
          }}
        >
          <Space onClick={() => setActive(true)}>
            <img
              src={
                view === "silences"
                  ? "/alerticons/silencewhite.svg"
                  : "/alerticons/iconsilence.svg"
              }
              alt="Silences Icon"
            />
            <span style={{ color: isDark ? (view === "silences" ? "#fff" : "#adbac7") : undefined }}>
              Silences
            </span>
          </Space>
        </Radio.Button>
        <Radio.Button
          value="contact-points"
          onChange={(e) => setActive(e.target.value)}
          className="morph-btn"
          style={{
            color: isDark ? (view === "contact-points" ? "#fff" : "#adbac7") : undefined,
          }}
        >
          <Space>
            <MailOutlined style={{ fontSize: 16 }} />
            <span style={{ color: isDark ? (view === "contact-points" ? "#fff" : "#adbac7") : undefined }}>
              Contact Points
            </span>
          </Space>
        </Radio.Button>
      </Radio.Group>

      <div style={{ flex: 1, minHeight: 0, overflow: "hidden", display: "flex", flexDirection: "column" }}>
        {renderContent()}
      </div>
    </div>
  );
};

export default AlertsPage;
